import React, { useState, useEffect, useRef } from "react";
import { useOutletContext } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Grid, TableContainer, IconButton } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import {
  saveLoanDetails,
  saveSchemeChannel,
} from "../../../../../store/reducers/LoanDetail/LoanDetailSlice";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ViewImageModal from "../ViewImage/ViewImageModal";
import hideChannels from "../../../../../../src/assets/constants/config/config";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";
import { CHECK_LOAN_MARKINGS } from "assets/properties/properties";
import { removeSpecialCharFileName } from "utils/Utils";
import { loanApplicationStatus } from "assets/properties/properties";
import { headerLabel } from "assets/properties/properties";
import { packetSizesOptions } from "assets/properties/properties";
import LoanDetails from "./LoanDetails/LoanDetails";
import OrnamentTableModal from "./OrnamentTable/OrnamentTableModal";
import CustomTable from "components/Table/Table";
import { nonEditableTableColumns } from "assets/properties/properties";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { repledgeCaseListName } from "assets/properties/properties";
import LoanSchemeModal from "../LoanScheme/LoanSchemeModal";
import { sortByString } from "utils/Utils";
import { collateralOperationStatus } from "assets/properties/properties";
import { panAmountValidate } from "utils/Utils";
import { APPLICATION_TYPE_RE_PLEDGE } from "assets/properties/properties";
import { checkCollateralType, getLoanLtvAmount, getPrepledgeLoanDues, getProcessingFeeApi, getSchemeChannelList, getTotalLoanAmount, GetUserDetails, handleLoanValidation, personalLoanElegiblity } from "./OrnamentV2Api";
import { calculateTotalTareWeight, normalizePacketAndOwnership, validateNetWeightPercentage } from "./OrnamentValidation";
import HoverImagePreview from "components/Common/HoverImagePreview";
import { fullSourceOfOwnershipOptions } from "assets/properties/properties";
import { simplifiedSourceOfOwnershipOptions } from "assets/properties/properties";
import { ZERO_VALUE } from "assets/properties/properties";
import { PACKET_ALREADY_ASSIGNED } from "assets/properties/properties";
import { APPLICATION_TYPE_New } from "assets/properties/properties";
import InFlowLoanDetails from "./LoanDetailsCreditAssessment/InFlowLoanDetails";
import OutFlowLoanDetails from "./LoanDetailsCreditAssessment/OutFlowLoanDetails";
import { annualIncomeValidate } from "../CreditAssement/Validation";
import { formatAmount } from "utils/Utils";
import ConfirmationModal from "views/components/ConfirmationModal";
import { APPLICATION_SUB_TYPE_POST_PLEDGE } from "assets/properties/properties";
import { loanTypes } from "assets/properties/properties";
const Ornament = ({
  setNext,
  loanApplicationId,
  loanApplicationNumber,
  editable,
  status,
  classes,
  mobileNum,
  totalCollateralValue,
  loanType,
  setCrossSell,
  subStatus,
  leadBranchCode,
  featureFlags,
  prePledgeLoan,
  newOrnamentsToggle,
  setNewOrnamentsToggle,
  firstTab,
  setBack,
  existingLoanData,
  prepledgeLoanMap,
  productType
}) => {
  const previousSchemeRef = useRef(null);
  const blurCompletedRef = useRef(false);
  const ornamentType =
    productType === loanTypes?.silverLoan
      ? "SILVER"
      : productType === loanTypes?.diamondLoan
        ? "GOLD_DIAMOND"
        : "GOLD";
  const [rawData, setRawData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const { userDetails } = useSelector((state) => state.userDetail.userDetails);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [totalGrossWeight, setTotalGrossWeight] = useState("");
  const [totalNetWeight, setTotalNetWeight] = useState("");
  const [originalTotalNetWeight22k, setOriginalTotalNetWeight22k] = useState("");
  const [totalTareWeight, setTotalTareWeight] = useState("");
  const [lastIndex, setLastIndex] = useState(-1);
  const [groupDetails, setGroupDetails] = useState([]);
  const [groupDetailsOriginal, setGroupDetailsOriginal] = useState([]);
  const [ornamentValues, setOrnamentValue] = useState([]);
  const [eligibleLoanAmount, setEligibleLoanAmount] = useState("");
  const [collateralValue, setCollateralValue] = useState("");
  const [loanData, setLoanData] = useState([]);
  const [actualLoanAmount, setActualLoanAmount] = useState("");
  const [actualLoanAmountWithInterest, setActualLoanAmountWithInterest] = useState("");
  const [actualLoanAmountState, setActualLoanAmountState] = useState(false);
  const [ltv, setLtv] = useState("");
  const [updatedInterestLtv, setUpdatedInterestLtv] = useState("");
  const [tenure, setTenure] = useState("");
  const [schemeList, setSchemeList] = useState([]);
  const [selectedScheme, setSelectedScheme] = useState({});
  const [loanSchemeCode, setLoanSchemeCode] = useState("");
  const [selectedSchemeName, setSelectedSchemeName] = useState({});
  const [enableActualLoanAmount, setEnableActualLoanAmount] = useState(false);
  const [newOrnamentsToggleDisabled, setNewOrnamentsToggleDisabled] = useState(false);
  const [monthlyInterest, setMonthlyInterest] = useState("");
  const [parseSchemeData, setParseSchemeData] = useState([]);
  const { authToken } = useSelector((state) => state.login.authData);
  const [ornamentGetData, setOrnamentGetData] = useState(false);
  const [getOrnamentDataLength, setGetOrnamentDataLength] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [selectedSchemeChannel, setSelectedSchemeChannel] = useState("");
  const [remarks, setRemarks] = useState("");
  const [deductionValue, setDeductionValue] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [schemeChannelState, setSchemeChannelState] = useState(false);
  const [parentTypeState, setParentTypeState] = useState(false);
  const [oldLoanDetailsData, setOldLoanDetailsData] = useState([]);
  const dispatch = useDispatch();
  const [ornamentList, setOrnamentList] = useState([]);
  const [disableNext, setDisableNext] = useState(false);
  const [packetError, setPacketError] = useState(false);
  const [availablePacketNumber, setAvailablePacketNumber] = useState([]);
  const [alreadyPacket, setAlreadyPacket] = useState(false);
  const [referalError, setReferalError] = useState(false);
  const [referral, setReferral] = useState("");
  const [referralName, setreferralName] = useState("");
  const [referralNameList, setreferralNameList] = useState([]);
  const [referralNameError, setreferralNameError] = useState(false);
  const [referralContact, setReferralContact] = useState("");
  const [referralContactError, setReferralContactError] = useState(false);
  const [referralAccount, setReferralAccount] = useState("");
  const [referralAccountError, setreferralAccountError] = useState(false);
  const [getOrnamentData, setGetOrnamentData] = useState(false);
  const [revisedLoanAmount, setRevisedLoanAmount] = useState(null);
  const [revisedRoi, setRevisedRoi] = useState(null);
  const [viewImageModal, setViewImageModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [showUpload, setShowUpload] = useState(true);
  const [grossWeightChange, setGrossWeightChange] = useState(false);
  const [crossCell, setCrossCell] = useState("");
  const [personalLoanElegiblityAmount, setPersonalElegibleLoanAmount] =
    useState("");
  const [totalAmountPerYear, setTotalLoanAmountPerYear] = useState(0);
  const [customerId, setCustomerId] = useState("");
  const [showOrnamentTableModal, setShowOrnamentTableModal] = useState(false);
  const maxLoanAmountPercentageFlag = Number(featureFlags?.maxLoanPercentage);
  const [maxLoanAmountPercentage,setMaxLoanAmountPercentage] = useState(maxLoanAmountPercentageFlag);
  const [minNetWeightValue, setMinNetWeightValue] = useState(0);
  const [prepledgeLoanAmount, setPrePledgeLoanAmount]=useState(0);
  const [annualIncome, setAnnualIncome] = useState("");
  const [meanPurposeOfLoan, setMeanPurposeOfLoan] = useState("");
    const [additionalIncomeList, setAdditionalIncomeList] = useState([
      {
        additionalSource: "",
        additionalIncome: "",
        address:"",
        attachment:"",
        attachmentType:"",
      },
    ]);
  const [foirConfig, setFoirConfig]=useState([])
  const [exposureData, setExposureData]=useState({})
  const [creditScore, setCreditScore]=useState(0);
  const [criffCalled, setCriffCalled]=useState(false);
  const [otherEmi, setOtherEmi] = useState("");
  const [cibilObiligationsData, setCibilObiligationsData] = useState([]);
  const outletData = useOutletContext();
  const featureFlag = featureFlags;
  const checkForAuditedFlagOrnamentFlag = parseAndSetFlag(featureFlags?.checkForAuditedFlagOrnamentFlag);
  const checkForUnacceptableItemFlag = parseAndSetFlag(featureFlags?.checkForUnacceptableItemFlag);
  const enabledPacketChangeInRenewalModal = parseAndSetFlag(featureFlags?.enabledPacketChangeInRenewalModal);
  const enabledSamePacketNumberOrnamentCheck = parseAndSetFlag(featureFlags?.enabledSamePacketNumberOrnamentCheck);
  const enableMinAndAnnualInterestRate = parseAndSetFlag(featureFlags.enableMinLtvAndInterestRate)
  const checkOrnamentUpdateForPartialRelease = parseAndSetFlag(featureFlags.checkOrnamentUpdateForPartialRelease)
  const skipUnacceptableItemValidationForPartRelease = parseAndSetFlag(featureFlags.skipUnacceptableItemValidationForPartRelease);
  const validateThirdPartyAttemptsFlag = parseAndSetFlag(featureFlags?.validateThirdPartyAttemptsFlag);
  const enabledUploadForm60Options = parseAndSetFlag(featureFlags?.enabledUploadForm60Options);
  const loanAmountForFrom60 = Number(featureFlag?.loanAmountForFrom60);
  const showDeleteButtonOnRenewalCases = parseAndSetFlag(featureFlag?.showDeleteButtonOnRenewal);
  const minLtvPercentage = parseAndSetFlag(featureFlag?.minLtvPercentage);
  const selectSchemeModal = parseAndSetFlag(featureFlag?.enableNewSchemeUi);
  const allowDeductionPercentage = featureFlag?.allowDeductionPercentage;
  const annualIncomeAmount = outletData?.annualIncomeFlag;
  const closureTimePayableAdjust = parseAndSetFlag(featureFlag?.closureTimePayableAdjust)
  const closureTimeExceedAmount = parseAndSetFlag(featureFlag?.closureTimeExceedAmount)
  const getSchemeBaseOnLoanType = parseAndSetFlag(featureFlag?.enableLoanTypeInScheme)
  const enabledApiBasedLtv = parseAndSetFlag(featureFlag?.enabledApiBasedLtv)
  const [enabledLeadValidateForNewLoan,setenabledLeadValidateForNewLoan] = useState(false);
  const [chargesData, setChargeData]=useState({})
  const noTopLoans=  typeof featureFlag?.noTopUpLoanTypes !== "undefined" ?  JSON.parse(featureFlag?.noTopUpLoanTypes) : []
  const notEligibleTopUpAccountType = noTopLoans?.includes(subStatus) && editable;
  const prePledgeLoanAmountMinus=  typeof featureFlag?.prePledgeLoanAmountMinus !== "undefined" ?  JSON.parse(featureFlag?.prePledgeLoanAmountMinus) : [];
  const prePledgeLoanAmountMinusType = prePledgeLoanAmountMinus?.includes(subStatus) && editable;
  const disableExistingOrnamentFields = parseAndSetFlag(featureFlag?.disableFieldOnExistingOrnaments);
  const enabledCreditAssessmentOnLoanDetails = parseAndSetFlag(featureFlag?.enabledCreditAssessmentOnLoanDetails);
  const enabledLtvSchemeBased = parseAndSetFlag(featureFlag?.enabledLtvSchemeBased);
  const [totalOutstandingAmount,setTotalOutstandingAmount] = useState(0);
  const [totalPreviousLoanInterestAmount,setTotalPreviousLoanInterestAmount] = useState(0);
  const [totalCurrentLoanInterestAmount,setTotalCurrentLoanInterestAmount] = useState(0);
  const [form60Link, setForm60Link] = useState("");
  const enabledValidationForRepledgeOrnament = parseAndSetFlag(
    featureFlags?.enabledValidationForRepledgeOrnament
  );
  const enabledMultiLoanAdjsutmentTopUp=  typeof featureFlag?.enabledMultiLoanAdjsutmentTopUp !== "undefined" ?  JSON.parse(featureFlag?.enabledMultiLoanAdjsutmentTopUp) : []
  const branchCodeSpecifiedSchemeFlag = parseAndSetFlag(
    featureFlags.branchCodeSpecifiedSchemeFlag
  );
  const enabelPacketNumber = featureFlags.enablePacketNumberFlag;
  const checkForExposureAmountFlag = parseAndSetFlag(
    featureFlags.checkForExposureAmountFlag
  );
  const checkForRestrictionFlag = parseAndSetFlag(
    featureFlags.checkForRestrictionFlag
  );
  const exposureAmountFlag = featureFlags.exposureAmountFlag;
  const PANCRITERIA = Number(featureFlag?.panThreshHoldFlag);
  const addDefaultTareWeight = featureFlags.addDefaultTareWeight;
  const showAdjustmentLoanDetailsFields = parseAndSetFlag(
    featureFlag?.showAdjustmentLoanOrnamentFlag
  );
  const enabledV2InprocessTab = parseAndSetFlag(
      outletData?.enabledV2InprocessTab
    );
  const cashThreshHoldFlag = outletData?.cashThreshHoldFlag;
  const checkActualLoanAmountPerYear = parseAndSetFlag(
    featureFlags.checkTotalLoanAmountInYear
  );
  const showNewChannelonBT = parseAndSetFlag(
    featureFlags.showNewChannelOnBTPostPledge
  );
  const enabledMinMAxPercentageFieldsCharges = parseAndSetFlag(
    featureFlags?.enabledMinMAxPercentageFieldsCharges
  );
  const removeSourceOfOwnershipFlag = parseAndSetFlag(
    featureFlags?.removeSourceOfOwnershipFlag
  );
  const iflActualLoanAmount =
    Number(totalAmountPerYear) + Number(actualLoanAmount);
  const [changeOrnamentData, setChangeOrnamentData] = useState(false);
  const [totalExposureAmount, setTotalExposureAmount] = useState("");
  const [packetSizeUpdate, setPacketSizeUpdate] = useState(true);
  const [editIndex,setEditIndex] = useState('');
  const [editIndexData,setEditIndexData] = useState({});
  const [panNumber, setPanNumber]= useState("");
  const [panVerified, setPanVerified]= useState("");
  const [panApplicantName, setPanApplicantName]= useState("");
  const [totalChargeAmount, setTotalChargeAmount]=useState(0);
  const [addChargeChange, setAddChargeChange]=useState(true);
  const YEARLYPANCRITERIA = Number(outletData?.panThreshHoldYearlyFlag);
  const [netWeightUnacceptableItem, setTotalNetWeightUnaAcceptableItem]=useState(0)
  const [newCustomer, setNewCustomer]=useState(false)
  const [disabledSchemeFields, setDisabledSchemeFields] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [confirmationModalBulletScheme, setConfirmationModalBulletScheme] = useState(false);
  const [confirmationModalHeaderBulletScheme, setConfirmationModalHeaderBulletScheme] = useState("");
  const [confirmationModalMsgBulletScheme, setConfirmationModalMsgBulletScheme] = useState("");
  const [tempSelectedScheme, setTempSelectedScheme] = useState(null);
  const [recalculateAmount, setRecalculateAmount] = useState(false);
  const [updatedPrepledgeLoanMap, setUpdatedPrepledgeLoanMap] = useState(prepledgeLoanMap);
  const statuses = status === loanApplicationStatus?.inProcess || status === loanApplicationStatus?.aadhaar || status === loanApplicationStatus?.selfie
  // for topup and renewal journey check eligible or not
  useEffect(() => {
    if(statuses && (subStatus === repledgeCaseListName?.topUp || subStatus === repledgeCaseListName?.renew)){
      getLoanLtvAmount(setCallInProgress, subStatus, mobileNum, prePledgeLoan, authToken, toastUpdate, setMaxLoanAmountPercentage, enabledApiBasedLtv, enabledLtvSchemeBased);
    }
  }, [subStatus]);
    const sourceData = !removeSourceOfOwnershipFlag
      ? fullSourceOfOwnershipOptions
      : simplifiedSourceOfOwnershipOptions;
// <-------------------- END------------------>
// <----- get Ornament List and Scheme Channel list(No Top Up Amount Loans) ----->
  useEffect(() => {
    if (statuses) {
      handleOrnamentList();
    if(notEligibleTopUpAccountType){
      getSchemeChannelList(authToken,toastUpdate , dispatch, saveSchemeChannel, setSchemeChannel);
    }
    }
  }, []);

// <----- Not First Tab then For check yearly amount for pan Validation ---->
  useEffect(() => {
    if (statuses && customerId && checkActualLoanAmountPerYear && !firstTab) {
      const totalLoanAmountInYear = getTotalLoanAmount(customerId, authToken)
      setTotalLoanAmountPerYear(totalLoanAmountInYear);
    }
  }, [customerId]);

  // <---------- Get User Details and update referral Name List ------->
   useEffect(() => {
    const fetchUserDetails = async () => {
      if (referral === "Internal" && statuses) {
        const userDetailData = await GetUserDetails(
          setCallInProgress,
          authToken,
          toastUpdate
        );
        setreferralNameList(userDetailData);
      }
    };
    fetchUserDetails();
  }, [referral, status]);

  // when cross cell is true then check personal loan eleigiblity 
  useEffect(() => {
    if (crossCell?.CROSS_SELL === true) {
      personalLoanElegiblity (authToken, loanApplicationId,actualLoanAmount,selectedScheme, setPersonalElegibleLoanAmount );
    }
  }, [crossCell]);
  useEffect(() => {
    if (!enabledCreditAssessmentOnLoanDetails && !enabledLtvSchemeBased) {
      return;
    }
    if (editable) {
      if (enabledCreditAssessmentOnLoanDetails) {
        getFoirConfig();
      }
      getExposureAmount();
    }
    if(enabledCreditAssessmentOnLoanDetails){
      getCreditAssementDetails();
    }
  },[ enabledCreditAssessmentOnLoanDetails,enabledLtvSchemeBased, editable]);
  useEffect(() => {
    if(enabledApiBasedLtv && editable){
      loanEligibilityDetails();
    }
  },[]);
  const loanEligibilityDetails = async (updateValue) => {
    setCallInProgress(true);
    try {
      const result = await apiHandler({
        url:
          endpoint.GET_LOAN_TOP_AND_RENEAL_DETAILS +
          mobileNum +
          `/renewal/false/topup/false?source=WEB`,
        method: "GET",
        authToken,
      });
      if (result?.data?.error_code) {
        toastUpdate(
          "Error",
          result?.data?.user_description || "Something went wrong",
          true,
        );
        return;
      }
      const loans = Array.isArray(result?.data) ? result.data : [];
      let currentPrepledgeMap = updatedPrepledgeLoanMap;
      if (updateValue) {
        const newMap = { ...updatedPrepledgeLoanMap };
        loans.forEach((loan) => {
          const loanAccountNumber = loan?.loanAccountNumber;
          if (
            Object.prototype.hasOwnProperty.call(
              newMap,
              loanAccountNumber,
            )
          ) {
            newMap[loanAccountNumber] = Number(
              loan?.netClosureAmount || 0,
            );
          }
        });
        setUpdatedPrepledgeLoanMap(newMap);
        currentPrepledgeMap = newMap;
      }
      const totalCollateralValue = loans.reduce((acc, loan) => {
        const loanAccountNumber = loan?.loanAccountNumber;
        if (
          Object.prototype.hasOwnProperty.call(
            currentPrepledgeMap,
            loanAccountNumber,
          )
        ) {
          return acc;
        }
        return acc + Number(loan?.currentCollateralValue || 0);
      }, 0);

      setCollateralValue(totalCollateralValue);
      setLoanData(result?.data);
    } catch (error) {
      console.log("loanEligibilityDetails error:", error);

      toastUpdate(
        "Error",
        "Unable to fetch loan eligibility details.",
        true,
      );
    } finally {
      setCallInProgress(false);
    }
  };
  const getCreditAssementDetails = async () => {
      setCallInProgress(true)
      const result = await apiHandler({
        url: endpoint.CREDIT_ASSESSMENT_DATA_FIND + loanApplicationId,
        authToken: authToken,
      });
      setCallInProgress(false)
      if(Number(result?.data?.existingMonthlyEmiObligation) > 0 || Number(result?.data?.creditScore) > 0){
        setOtherEmi(result?.data?.existingMonthlyEmiObligation); 
        setCreditScore(result?.data?.creditScore);
        setCriffCalled(true);
      }
        const data = result?.data;
        if(!editable){
          setTotalPreviousLoanInterestAmount(data?.prevLoanInterest);
          setTotalOutstandingAmount(data?.totalOutstandingAmount);
          setTotalCurrentLoanInterestAmount(data?.currentLoanInterest);
        }
        if (
          Array.isArray(data?.additionalDetails) &&
          data.additionalDetails.length
        ) {
          setAdditionalIncomeList(
            data.additionalDetails.map((item) => ({
              additionalSource: item.name,
              additionalIncome: Math.round(Number(item.amount)),
              attachment: item.attachment,
              address: item.address,
              attachmentType:item?.attachmentType,
            }))
          );
        } else {
          setAdditionalIncomeList([
            {
              additionalSource: "",
              additionalIncome: "",
              address: "",
              attachment: "",
              attachmentType:"",
            },
          ]);
        }
        setAnnualIncome(data?.annualIncome);
    };
  const DocumentStatusHelper = async (value, verified) => {
    setCallInProgress(true)
    const result = await apiHandler({
      url: endpoint.CHECK_PROFILE_RESTRICTION + value?.[0]?.customerId,
      authToken: authToken,
    });
    setCallInProgress(false)
    setTotalExposureAmount(result?.data?.totalDisbursedLoanAmt);
    let prePledgeLoanAmt = 0
      if(statuses && prePledgeLoanAmountMinusType && Object?.keys(updatedPrepledgeLoanMap)?.length <= 1){
      const prePledgeLoanData = await getPrepledgeLoanDues(authToken, setCallInProgress, prePledgeLoan, toastUpdate, featureFlags);
      const loanAmountAdjustedLoan = Number(prePledgeLoanData?.totalDues) - Number(prePledgeLoanData?.interestWaiveOffAmt) - (closureTimePayableAdjust ? Number(prePledgeLoanData?.payableAmount) : 0) + (closureTimeExceedAmount ? Number(prePledgeLoanData?.excessInterestAmount) : 0);
      setPrePledgeLoanAmount(prePledgeLoanData?.loanAmount)
      if(subStatus === repledgeCaseListName?.partRelease || subStatus === repledgeCaseListName?.renew){
      setActualLoanAmount(loanAmountAdjustedLoan)
      }
      prePledgeLoanAmt = prePledgeLoanData?.loanAmount
     }
    
    if (
      Number(result?.data?.totalDisbursedLoanAmt) - Number(prePledgeLoanAmt) >
        Number(exposureAmountFlag) &&
      checkForExposureAmountFlag
    ) {
      toastUpdate(
        "Error",
        `For this customer exposure is getting more than ${Number(
          exposureAmountFlag
        )}`,
        true
      );
      setDisableNext(true);
      return false;
    }
    const isDueDiligenceOnly =
      subStatus === repledgeCaseListName?.renew || subStatus === repledgeCaseListName?.topUp;
    const statusArray = result?.data?.markingActions;
    const deathOrLegalAccounts = result?.data?.restrictions.filter((entry) => {
      const loanMarkingAction = entry?.loanMarkingAction || "";
      const loanAuditActions = entry?.loanAuditActions || [];
      const hasSpuriousGold =
        loanAuditActions?.some(
          action =>
            action === `[${CHECK_LOAN_MARKINGS.spuriousGold}]` ||
            action === CHECK_LOAN_MARKINGS.spuriousGold
        );
      
      const hasUnacceptableItem =
        checkForUnacceptableItemFlag &&
        !(
          skipUnacceptableItemValidationForPartRelease &&
          (subStatus === repledgeCaseListName?.partRelease || subStatus === repledgeCaseListName?.renew)
        ) &&
        loanAuditActions?.some(
          action =>
            action === `[${CHECK_LOAN_MARKINGS.unacceptableItem}]` ||
            action === CHECK_LOAN_MARKINGS.unacceptableItem
        );
      if (isDueDiligenceOnly) {
        return (
          entry?.dueDiligence &&
          entry?.dueDiligence.trim() !== ""
        );
      }

      return (
        loanMarkingAction.includes(CHECK_LOAN_MARKINGS.death) ||
        loanMarkingAction.includes(CHECK_LOAN_MARKINGS.legal) ||
        (entry?.npa === true && entry?.status !== "CLOSED") ||
        (hasSpuriousGold && entry?.status !== "CLOSED") ||
          (hasUnacceptableItem && entry?.status !== "CLOSED") ||
        (entry?.dueDiligence && entry?.dueDiligence.trim() !== "")
      );
    });
    const filteredCases = deathOrLegalAccounts.filter((loan) => {
      const loanAuditActions = loan?.loanAuditActions || [];
    const hasSpuriousGold =
      loanAuditActions.includes(CHECK_LOAN_MARKINGS.spuriousGold);
    const hasUnacceptableItem =
      checkForUnacceptableItemFlag &&
      !(
        skipUnacceptableItemValidationForPartRelease &&
        subStatus === repledgeCaseListName?.partRelease
      ) &&
      loanAuditActions.includes(CHECK_LOAN_MARKINGS.unacceptableItem);

      if (isDueDiligenceOnly) {
        return (
          loan?.dueDiligence &&
          loan?.dueDiligence.trim() !== ""
        );
      }

      return (
        (loan?.status !== "CLOSED" &&
        (hasSpuriousGold || hasUnacceptableItem)) ||
        loan?.loanMarkingAction === CHECK_LOAN_MARKINGS.death ||
        loan?.loanMarkingAction === CHECK_LOAN_MARKINGS.legal ||
        (loan?.npa === true && loan?.status !== "CLOSED") ||
        (loan?.dueDiligence && loan?.dueDiligence.trim() !== "")
      );
    });
    const formatAction = (action) => {
      switch (action) {
        case CHECK_LOAN_MARKINGS.spuriousGold:
          return "SPURIOUS GOLD";
          case CHECK_LOAN_MARKINGS.unacceptableItem:
          return 'UNACCEPTABLE ITEM';
        default:
          return action;
      }
    };

    const groupedMessages = filteredCases?.reduce(
      (acc, loan) => {
        const formattedAuditActions = loan?.loanAuditActions
          ?.filter(
            (action) =>
              action === CHECK_LOAN_MARKINGS.spuriousGold ||
              (checkForUnacceptableItemFlag &&
              !(
                skipUnacceptableItemValidationForPartRelease &&
                subStatus === repledgeCaseListName?.partRelease
              ) &&
                action === CHECK_LOAN_MARKINGS.unacceptableItem)
          )
          ?.map(formatAction)
          ?.join(", ");

        const formattedMarkingAction =
          loan?.loanMarkingAction === CHECK_LOAN_MARKINGS.death ||
          loan?.loanMarkingAction === CHECK_LOAN_MARKINGS.legal
            ? loan.loanMarkingAction
            : "";

        const npaStatus = loan?.npa ? "NPA" : "";
        const dueDiligence = loan?.dueDiligence
          ? `Due Diligence: ${loan.dueDiligence}`
          : "";

        const messageParts = [];
        if (formattedAuditActions) messageParts.push(formattedAuditActions);
        if (formattedMarkingAction) messageParts.push(formattedMarkingAction);
        if (npaStatus) messageParts.push(npaStatus);
        if (dueDiligence) messageParts.push(dueDiligence);

        const messageContent = messageParts.join(" and ");

        const message = `For this customer, against ${loan.loanAccountNumber} loan status is ${messageContent}.\n`;

        if (!acc.processedAccounts.has(loan.loanAccountNumber)) {
          if (acc.groupedMessages[loan.loanAccountNumber]) {
            acc.groupedMessages[loan.loanAccountNumber].push(message);
          } else {
            acc.groupedMessages[loan.loanAccountNumber] = [message];
          }
          acc.processedAccounts.add(loan.loanAccountNumber);
        }

        return acc;
      },
      { groupedMessages: {}, processedAccounts: new Set() }
    );

    const noticeMessages = Object.entries(groupedMessages.groupedMessages)
      .map(([accountNumber, messages]) => messages.join(""))
      .join("");

    const joinLoanAccountNumber = Object.keys(
      groupedMessages.groupedMessages
    ).join(", ");
    const shouldShowPopup =
      isDueDiligenceOnly
        ? joinLoanAccountNumber 
        : joinLoanAccountNumber &&
          (!checkForRestrictionFlag ||
            (checkForRestrictionFlag && result?.data?.restriction));
    if (shouldShowPopup) {
      toastUpdate("Error", noticeMessages, true);
      setDisableNext(true);
    }
  };
  const getFoirConfig = async () => {
      setCallInProgress(true)
      const res = await apiHandler({
        url: endpoint.FOIR_MASTER_FIND_ALL,
        authToken: authToken,
      });
      setCallInProgress(false)
     if(res?.data?.length > 0 && !res?.data?.error_code){
        setFoirConfig(res?.data)
      }
    };

  const GetProfileData = async (verified) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.SEARCH_PROFILE + mobileNum?.trim(),
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!res?.data?.error_code) {
      const customerIds = res?.data?.map((customer) => customer?.customerId);
      const customerIdsString = customerIds?.join(", ");
      const errorMessage = `Multiple Customer id ${customerIdsString} exists with same mobile number. Kindly correct the same before new loan creation.`;
      if (res?.data?.length > 1) {
        toastUpdate("Error", errorMessage, true);
        setDisableNext(true);
      } else if (res?.data?.length === 1) {
        setCustomerId(res?.data?.[0]?.customerId);
        if (
          mobileNum?.trim() ===
          res?.data?.[0]?.communication?.primarymobileNumber?.trim()
        ) {
          DocumentStatusHelper(res?.data);
        }
      } else {
        setNewCustomer(true)
        setDisableNext(false);
      }
    } else {
      setNewCustomer(true)
      setDisableNext(false);
    }
  };
  const handleOrnamentList = async () => {
    const apiProductType = productType === loanTypes?.silverLoan ? productType : loanTypes?.goldLoan
    const result = await apiHandler({
      url: endpoint.ORNAMENT_LIST_DATA + `&productType=${apiProductType}`,
      authToken: authToken,
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setOrnamentList(result?.data);
      await handleLoanValidation(authToken, setenabledLeadValidateForNewLoan, toastUpdate, setMinNetWeightValue );
    }
  }
  const isExistingRow = (index) => !!groupDetailsOriginal[index];
  const handleOrnamentValue = (event, index) => {
    const value = parseFloat(event.target.value);
    const newArr = [...groupDetails];
    const item = newArr[index];
    const original = groupDetailsOriginal[index];

    const ornamentDetail = ornamentList.find(
      (o) => o.name === item.particulars
    );
    if (!ornamentDetail) return;

    const minAllowed = ornamentDetail.minGrossWeight * (item.itemCount || 1);
    const maxAllowed = ornamentDetail.maxGrossWeight * (item.itemCount || 1);

    if (enabledValidationForRepledgeOrnament && isExistingRow(index)) {
      const isRenewalFlow =
        loanType?.toUpperCase() === "RE_PLEDGE" &&
        ["TOP_UP", "RENEWAL"].includes(subStatus?.toUpperCase());
      const isBranchUser = userDetails?.rootHierarchy === false;

      if (isRenewalFlow && isBranchUser) {
        const previousValue = parseFloat(original?.grossWeight);
        if (!isNaN(previousValue) && value > previousValue) {
          toastUpdate(
            "Error",
            `Gross weight cannot exceed the original (${previousValue}).`,
            true
          );
          newArr[index] = {
            ...item,
            grossWeight: previousValue,
            grossWeightError: true,
          };
          setGroupDetails(newArr);
          setDisableNext(true);
          return;
        }
      }
    }

    if (value < minAllowed || value > maxAllowed) {
      toastUpdate(
        "Error",
        `Entered Gross weight for ${ornamentDetail.name} must be between ${minAllowed} and ${maxAllowed}.`,
        true
      );
      newArr[index] = { ...item, grossWeightError: true };
      setGroupDetails(newArr);
      setDisableNext(true);
      return;
    }

    newArr[index] = { ...item, grossWeight: value, grossWeightError: false };
    setGroupDetails(newArr);
    setDisableNext(false);
    updateOrnamentDetails(event, index);
  };

  const getPacketNumbers = async (selectedSize, index, name) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url:
        endpoint.PACKETS_SERIAL_NUMBER +
        leadBranchCode +
        "?size=" +
        selectedSize,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
      return;
    }
    let newArr = [...groupDetails];
    if (getOrnamentData && packetSizeUpdate) {
      updateTareWeight(groupDetails);
      return;
    }

    let item = newArr[index];
    const serialNumberMap = result?.data?.serialNumberMap;
    let packetNumbers = Array.isArray(result?.data?.serialNumbers)
      ? result.data.serialNumbers
      : serialNumberMap && typeof serialNumberMap === "object"
        ? Object.keys(serialNumberMap)
        : [];

    // Get all previous selections for the current size
    let previousSelections = newArr
      .filter(
        (otherItem, otherIndex) =>
          otherItem.packetSize === selectedSize && otherIndex !== index
      )
      .map((item) => item.packetNumber)
      .filter(Boolean);

    previousSelections = [...new Set(previousSelections)];

    let nextPacketIndex = previousSelections.length;

    // If packet numbers are not available, keep packetNumber empty
    let selectedPacket = packetNumbers.length
      ? item.packetNumber || packetNumbers[0]
      : "";

    const enablePacketNumberFirstTime =
      Number(enabelPacketNumber) === 0 ? 1 : Number(enabelPacketNumber);

    let availablePacketNumber = packetNumbers.map((packet, i) => ({
      value: packet,
      disabled:
        previousSelections.length === 0
          ? !(i < enablePacketNumberFirstTime)
          : !(
              i <= nextPacketIndex + (Number(enabelPacketNumber) - 1) ||
              previousSelections.includes(packet)
            ),
      ...(serialNumberMap &&
      Object.prototype.hasOwnProperty.call(serialNumberMap, packet)
        ? { weight: serialNumberMap[packet] }
        : {}),
    }));

    const mappedPacketWeight =
      serialNumberMap &&
      Object.prototype.hasOwnProperty.call(serialNumberMap, selectedPacket)
        ? serialNumberMap[selectedPacket]
        : result?.data?.packetWeight;

    item = {
      ...item,
      packetNumber: selectedPacket,
      availablePacketNumber: availablePacketNumber,
      packetSize: selectedSize,
      packetWeight: Number(mappedPacketWeight) || 0,
    };

    const isDuplicatePacket =
      selectedPacket &&
      newArr.some(
        (otherItem, otherIndex) =>
          otherIndex !== index && otherItem.packetNumber === selectedPacket
      );

    if (!isDuplicatePacket) {
      const packetWeight = Number(item.packetWeight) || 0;

      item.tareWeight =
        Number(item.grossWeight || 0) + packetWeight;
    } else {
      item.tareWeight = Number(item.grossWeight || 0);
    }

    newArr[index] = item;

    setGroupDetails(newArr);
  };

  const handleStoneWeight = async (event, index) => {
    let name = event.target.name;
    let value = event.target.value;
    const result = await apiHandler({
      url: endpoint.STONE_WEIGHT,
      method: "POST",
      authToken: authToken,
      data: {
        stoneWeight: Number(value),
        grossWeight: groupDetails[index].grossWeight,
      },
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", "Stone Deduction is not in acceptable limit", true);
      setDisableNext(true);
    } else {
      let newArr = [...groupDetails]; // copying the old data;'s array
      let item = newArr[index];
      setDisableNext(false);
      item = {
        ...item,
        deduction: result?.data?.standardDeductionWeight,
        netWeight:
          item.grossWeight -
          Number(event.target.value) -
          result?.data?.standardDeductionWeight,
      };
      newArr[index] = item;
      let newOrnamentArray = [...ornamentValues];
      let ornamentItem = newOrnamentArray[index];
      ornamentItem = {
        ...ornamentItem,
        deduction: result?.data?.standardDeductionWeight,
      };
      newOrnamentArray[index] = ornamentItem;
      setOrnamentValue(newOrnamentArray);
      setGroupDetails(newArr);
      handleCalculateWeight(index, newArr);
      // setTotalDeduction(
      //   totalDeduction + Number(result?.data?.standardDeductionWeight)
      // );
      setTotalNetWeight(
        totalNetWeight - Number(result?.data?.standardDeductionWeight)
      );
    }
  };
  const calculateWeightApiPath = productType === loanTypes?.silverLoan  ? endpoint.CALCULATE_WEIGHT_SILVER : endpoint.CALCULATE_WEIGHT;
  const handleCalculateWeight = async (index, newData) => {
    let payloadData = {}
    if(productType === loanTypes?.silverLoan ){
      payloadData = {
        netWeight: newData[index]?.netWeight,
        netWeightPurity: newData[index]?.finnesseCode,
        expectedNetWeightPurity: "999",
        productType:productType,
      }
    }else{
      payloadData = {
        netWeight: newData[index]?.netWeight,
        netWeightGoldPurity: newData[index]?.finnesseCode,
        expectedNetWeightGoldPurity: "22k",
        productType:productType,
      }
    }
    const result = await apiHandler({
      url: calculateWeightApiPath,
      method: "POST",
      authToken: authToken,
      data: payloadData,
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
        blurCompletedRef.current = false;
      let netWeight22k = 0;
      let newArr = [...newData]; // copying the old data's array
      let item = newArr[index];
      item = { ...item, netWeightWith22k: result?.data?.netWeight };
      newArr[index] = item;
      setGroupDetails(newArr);
      newArr.forEach((item, i) => {
        netWeight22k = netWeight22k + item.netWeightWith22k;
      });
      // setTotalNetWeightWith22k(netWeight22k);
    }
  };
  const handleDeductionUpdate = async (event, index) => {
    const value = event.target.value;
    let newArr = [...groupDetails]; // copying the old data's array
    let item = newArr[index];
    const result = await apiHandler({
      url: endpoint.STONE_WEIGHT,
      method: "POST",
      authToken: authToken,
      data: {
        stoneWeight: groupDetails[index].stoneWeight,
        grossWeight: groupDetails[index].grossWeight,
      },
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", "Stone Deduction is not in acceptable limit", true);
      setDisableNext(true);
    } else {
      if (value < result?.data?.standardDeductionWeight) {
        item = { ...item, deductionError: true };
        newArr[index] = item;
        setGroupDetails(newArr);

        toastUpdate(
          "Error",
          `Deduction cannot be less than ${result?.data?.standardDeductionWeight}`,
          true
        );
        setDisableNext(true);
      } else {
        item = { ...item, deductionError: false };
        newArr[index] = item;
        setGroupDetails(newArr);
        setDisableNext(false);
        updateOrnamentDetails(event, index);
      }
    }
  };

  const handleOrnamentCount = (event, index) => {
    let value = event.target.value;
    const ornamentDetail = ornamentList.filter(
      (item) => item.name === groupDetails?.[index]?.particulars
    );
    let newArr = [...groupDetails]; // copying the old data's array
    let item = newArr[index];

    if (value > ornamentDetail?.[0]?.maxAllowedCount) {
      setDisableNext(true);
      item = { ...item, countError: true, itemCount: "" };
      newArr[index] = item;
      setGroupDetails(newArr);
      toastUpdate(
        "Error",
        `Entered count for ${ornamentDetail[0]?.name} is not as per policy`,
        true
      );
      return false;
    } else {
      item = { ...item, countError: false };
      setDisableNext(false);
      newArr[index] = item;
      setGroupDetails(newArr);
      handleCalculateWeight(index, newArr);
    }
  };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
    const { reduxSchemeChannel } = useSelector(
    (state) => state.loanDetail.schemeChannel
  );
const [schemeChannel, setSchemeChannel]=useState(reduxSchemeChannel)
  let SchemeChannelData = [];
  if ((loanType === "NEW" || loanType === "RE_PLEDGE") && schemeChannel?.length > 0) {
    SchemeChannelData = schemeChannel?.filter((item) =>
      item?.channel?.includes("NEW")
    );
  } else if (
    loanType === "BT" &&
    subStatus === "POST_PLEDGE" &&
    showNewChannelonBT && schemeChannel?.length > 0
  ) {
    SchemeChannelData = schemeChannel?.filter(
      (item) => item?.channel?.includes("NEW") || item?.channel?.includes("BT")
    );
  } else if (loanType === "BT" && schemeChannel?.length > 0) {
    SchemeChannelData = schemeChannel?.filter((item) =>
      item?.channel?.includes("BT")
    );
  } else if (hideChannels?.length && typeof hideChannels !== "undefined" && schemeChannel?.length > 0) {
    SchemeChannelData = schemeChannel?.filter(
      (item) => !hideChannels?.includes(item?.channel)
    );
  }
  useEffect(() => {
    if (ornamentList?.length > 0 || status !== "INPROCESS")
      GetLoanOrnamentDetails();
  }, [ornamentList]);

  const GetLoanOrnamentDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ORNAMENT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      setNewOrnamentsToggleDisabled(false);
      if (loanType === "RE_PLEDGE" || subStatus === APPLICATION_SUB_TYPE_POST_PLEDGE) {
          updateData(existingLoanData?.ornamentDetails, false, newOrnamentsToggle);
      } else {
        GetProfileData();
      }
      return;
    } else {
      if(getSchemeBaseOnLoanType && editable && subStatus === APPLICATION_TYPE_New){
        const res = await apiHandler({
        url: endpoint.SEARCH_PROFILE + mobileNum?.trim(),
        authToken: authToken,
      });
        if(res?.data?.error_code || res?.data === ""){
          setNewCustomer(true)
        }
      }
      setNewOrnamentsToggleDisabled(true);
      if ((loanType === "RE_PLEDGE" || subStatus === APPLICATION_SUB_TYPE_POST_PLEDGE) && enabledValidationForRepledgeOrnament) {
          updateData(existingLoanData?.ornamentDetails, true, newOrnamentsToggle);
      }
      dispatch(
        saveLoanDetails({                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
          ornamentDetail: result.data,
        })
      );
      setOrnamentGetData(true);
      setGetOrnamentDataLength(result?.data?.ornamentDetails?.length);
      setReferralAccount(result?.data?.referralLoan);
      setReferralContact(result?.data?.referralContact);
      setReferral(result?.data?.referral);
      setreferralName(result?.data?.referralName);
      setRawData(result.data);
      setEligibleLoanAmount(result?.data?.eligibleLoanAmt?.toFixed(2));
      setTotalNetWeight(result?.data?.totalNetWeight);
      setTotalTareWeight(result?.data?.tareWeight?.toFixed(2));
      setRemarks(result?.data?.remarks);
      setTotalChargeAmount(result?.data?.totalChargeAmt || 0)
      setAddChargeChange(result?.data?.totalChargeAmt > 0 ? false : true);
      if (result?.data?.ornamentDetails?.length) {
        setGetOrnamentData(true);
      }
      setGroupDetails(
        result?.data?.ornamentDetails?.length > 0
          ? result?.data?.ornamentDetails.map((item) => ({
              ...item,
              ornamentType,
              particularsError: false,
              finnesseCodeError: false,
              countError: false,
              grossWeightError: false,
              stoneWeightError: false,
              deductionError: false,
              sourceOfOwnershipError: false,
              packetNumberError: false,
            }))
          : []
      );
      setLoanSchemeCode(result?.data?.loanSchemeCode);
      setLastIndex(
        result?.data?.ornamentDetails
          ? result?.data?.ornamentDetails.length - 1
          : -1
      );
      setActualLoanAmount(result?.data?.actualLoanAmount);
      setLtv("" + result?.data?.ltv);
      setTenure("" + result?.data?.tenureInMonths);
      setMonthlyInterest("" + result?.data?.monthlyInterest);
      setSelectedSchemeName(result?.data?.loanSchemeName);
      setEnableActualLoanAmount(true);
      setSelectedSchemeChannel(result?.data?.loanSchemeChannel);
      if (result?.data?.loanSchemeChannel) {
        getSchemeChannelList(authToken,toastUpdate , dispatch, saveSchemeChannel, setSchemeChannel);
      }
      const ornamentArray = result?.data?.ornamentDetails?.map((item) =>
        ornamentList.filter((data) => data.name === item.particulars)
      );
      setOrnamentValue(ornamentArray?.map((item) => item[0]));
      setRevisedLoanAmount(result?.data?.revisedLoanAmt || null);
      setRevisedRoi(result?.data?.revisedAnnualRoi || null)
      if (result?.data?.packetSize) {
        setAlreadyPacket(true);
      }
      parseIndicatorData(result?.data?.ornamentDetails,newOrnamentsToggle);
      if((enabledCreditAssessmentOnLoanDetails || enabledLtvSchemeBased) && status !== loanApplicationStatus?.inProcess){
        getExposureAmount();
      }
    }
  };
    const updateData = async (ornamentData, validationForRepledgeOrnament, ornamentNewJourney) => {
      let allLoanOrnamentData = ornamentData;
      const loanAccountNumbers = Object?.keys(updatedPrepledgeLoanMap);
      if(loanAccountNumbers?.length > 1 && enabledMultiLoanAdjsutmentTopUp?.includes(subStatus) && status === loanApplicationStatus?.inProcess  )
      {
        setCallInProgress(true);
          const result = await apiHandler({
            url: endpoint.GET_ALL_ORNAMENT_DATA,
            authToken: authToken,
            method:'POST',
            data:{
              loanAccountNumbers: loanAccountNumbers
            }
          });
          setCallInProgress(false);
          if (result?.data?.error_code) {
            toastUpdate("Error", result?.data?.user_description, true);
          } else {
            allLoanOrnamentData = result?.data;
          }
      }
       const unacceptableOrnaments = allLoanOrnamentData?.ornaments?.filter(ornament => ornament?.action?.includes(CHECK_LOAN_MARKINGS?.unacceptableItem)) || [];
       if(unacceptableOrnaments?.length > 0 && subStatus === repledgeCaseListName?.partRelease && checkOrnamentUpdateForPartialRelease){
        const result1 = await apiHandler({
          url: endpoint.AUCTION_RESERVE_PRICE + prePledgeLoan?.trim(),
          authToken: authToken,
        });
         const unacceptableIds = new Set(unacceptableOrnaments.map(o => o.ornamentId));
         const totalNetWeight22k = result1?.data?.ornaments?.filter(o => unacceptableIds.has(o.id))?.reduce((sum, o) => sum + (o?.netWeightWith22k || 0), 0) || 0;
          setTotalNetWeightUnaAcceptableItem(totalNetWeight22k)
       }
      const array = sortByString(
        allLoanOrnamentData?.ornaments,
        "ornamentId",
        true
      )?.map((item) => ({
        ...item,
        ornamentType,
      }));
      
        for (let i = 0; i < array?.length; i++) {
          // rename ornamentAudited → isOrnamentAudited
          if (array[i]?.ornamentAudited !== undefined) {
            array[i].isOrnamentAudited = array[i].ornamentAudited;
            delete array[i].ornamentAudited;
          }
          if(ornamentNewJourney){
          if (!array[i].additionalInfo) {
            array[i].additionalInfo = {};
          }
          // Empty packetSize
          array[i].packetSize = "";
          // Empty packetNumber
          array[i].packetNumber = "";
          // Set packetSealed to true
          array[i].packetSealed = true;
          //set Tare weight to total gross weight
          array[i].tareWeight = array[i].grossWeight;
          if(array?.[i]?.sourceOfOwnership === "" || typeof array?.[i]?.sourceOfOwnership === "undefined" || array?.[i]?.sourceOfOwnership === null){
            array[i].sourceOfOwnership = sourceData?.[0] || "";
          }
          if(loanType === "RE_PLEDGE" && disableExistingOrnamentFields){
              array[i].additionalInfo.disableExistingFields = true;
          }else{
              array[i].additionalInfo.disableExistingFields = false;
              array[i].additionalInfo.ornamentUpdated = false;
          }
          }else{
            array[i].packetSealNumber = "1";
            if(array[i]?.packetSize === "" || typeof array[i]?.packetSize === "undefined" || array[i]?.packetSize === null){
               array[i].packetSize = '10.0*6.5'|| ""; 
            }
            if(array?.[i]?.sourceOfOwnership === "" || typeof array?.[i]?.sourceOfOwnership === "undefined" || array?.[i]?.sourceOfOwnership === null){
              array[i].sourceOfOwnership = sourceData?.[0] || "";
            }
          }
          array[i].existingOrnament = !ornamentNewJourney;
          if (array[i]?.netWeightWith22k === 0) {
            let payloadData = {}
            if(productType === loanTypes?.silverLoan ){
              payloadData = {
                netWeight: array[i]?.netWeight,
                netWeightPurity: array[i]?.finnesseCode,
                expectedNetWeightPurity: "995",
                productType:productType,
              }
            }else{
              payloadData = {
                netWeight: array[i]?.netWeight,
                netWeightGoldPurity: array[i]?.finnesseCode,
                expectedNetWeightGoldPurity: "22k",
                productType:productType,
              }
            }
            const result = await apiHandler({
              url: calculateWeightApiPath,
              method: "POST",
              authToken: authToken,
              data:payloadData,
            });
            array[i].netWeightWith22k = result?.data?.netWeight;
          }
        }
        setOriginalTotalNetWeight22k(allLoanOrnamentData?.totalNetWeightWith22k);
        setOldLoanDetailsData(array ? array : []);
        if(validationForRepledgeOrnament){
         setGroupDetailsOriginal(array ? array : []);
         return;
        }
        setLastIndex(
          allLoanOrnamentData?.ornaments ? allLoanOrnamentData?.ornaments?.length - 1 : -1
        );
        setTotalGrossWeight(allLoanOrnamentData?.totalGrossWeight);
        setTotalNetWeight(allLoanOrnamentData?.totalNetWeight);
        setTotalTareWeight(allLoanOrnamentData?.totalGrossWeight?.toFixed(2));
        setRemarks(allLoanOrnamentData?.remarks);
        setReferralAccount(allLoanOrnamentData?.referralLoan);
        setReferralContact(allLoanOrnamentData?.referralContact);
        setReferral(allLoanOrnamentData?.referral);
       if (allLoanOrnamentData?.length > 0) {
          setGetOrnamentData(false);
        }
        setreferralName(allLoanOrnamentData?.referralName);
        setGroupDetails(array ? array : []);
        setGroupDetailsOriginal(array ? array : []);
        calculateEligibleLoanAmountApi(array);
        parseIndicatorData(array,ornamentNewJourney);
        setRevisedLoanAmount(allLoanOrnamentData?.revisedLoanAmt || null);
        setRevisedRoi(allLoanOrnamentData?.revisedAnnualRoi || null)
        await GetProfileData()
    }
  const packetSizeList =
    typeof featureFlag?.packetSizesList !== "undefined"
      ? JSON.parse(featureFlag?.packetSizesList)
      : packetSizesOptions;
 

    const onClickDeleteData = async (i, groupData) => {
    const item = groupData?.[i];
    const packetNum = item?.packetNumber;
    const isPacketRepeated = groupData.filter(
      (obj) => obj.packetNumber === packetNum
    );
    const totalDeletedTareWeight =
      Number(groupData?.[i]?.grossWeight) +
      Number(groupData?.[i]?.packetWeight);
    setTotalGrossWeight(
      Number(totalGrossWeight) - Number(groupData?.[i]?.grossWeight)
    );
    setTotalNetWeight(
      Number(totalNetWeight) - Number(groupData?.[i]?.netWeight)
    );
    setTotalTareWeight(
      isPacketRepeated?.length > 1
        ? Number(totalTareWeight) - Number(groupData?.[i]?.grossWeight)
        : Number(totalTareWeight) - totalDeletedTareWeight
    );
      if(!notEligibleTopUpAccountType){
      setActualLoanAmount("");
      }
    setSelectedScheme({});
    setSelectedSchemeChannel("");
    setChangeOrnamentData(true);
    const updateDetails = [...groupData.slice(0, i), ...groupData.slice(i + 1)];
    setGroupDetails(updateDetails);
    if(enabledValidationForRepledgeOrnament){
    setGroupDetailsOriginal((prev) => [
      ...prev.slice(0, i),
      ...prev.slice(i + 1),
    ]);}
    setLastIndex((prev) => prev - 1)
    calculateEligibleLoanAmountApi(updateDetails);
    updateTotalValues(updateDetails)
    parseIndicatorData(updateDetails,newOrnamentsToggle);
  };
  const onEditClick = (data, index) => {
    setEditIndex(index);
    setEditIndexData(data);
    setShowOrnamentTableModal(true);
  };
  const showDeleteButton=((checkForAuditedFlagOrnamentFlag && (userDetails?.rootHierarchy || (!userDetails?.rootHierarchy && subStatus === repledgeCaseListName?.partRelease))) || !checkForAuditedFlagOrnamentFlag)
  const getActionLink = (data, index, groupData) => {
  const showDeletedButton =  data?.action?.includes(CHECK_LOAN_MARKINGS?.unacceptableItem) && subStatus === "RENEWAL" && showDeleteButtonOnRenewalCases;
  const canShowActions = !(
    index > 0 &&
    disableExistingOrnamentFields &&
    data?.additionalInfo?.disableExistingFields === true &&
    subStatus === repledgeCaseListName?.topUp
  );

  if (!canShowActions) return null;
  const hideDelete = data?.additionalInfo?.disableExistingFields === true && disableExistingOrnamentFields && loanType === "RE_PLEDGE" && subStatus !== "PART_RELEASE";

  return (
    <div style={{ display: 'flex' }}>
      {!showDeletedButton && <IconButton aria-label="Edit" onClick={() => onEditClick(data, index)}>
        <EditIcon />
      </IconButton>}
      {((!hideDelete && (showDeleteButton || !data?.isOrnamentAudited)) || showDeletedButton) && (
        <IconButton aria-label="Delete" onClick={() => onClickDeleteData(index, groupData)}>
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  );
};

  const getImageLink = (i, imageUrl) => {
  return <HoverImagePreview imageUrl={imageUrl} />;
};
 const parseIndicatorData = (data, ornamentNewJourney) => {
    let reportData = [];
    data &&
      data.forEach((ornament, index) => {
        const packetSizeName = packetSizeList?.filter(
          (item) => item?.code === ornament?.packetSize
        );
        let row = [
          ornament?.particulars,
          ornament?.particulars,
          ornament?.finnesseCode,
          ornament?.itemCount,
          ornament?.grossWeight,
          ornament?.stoneWeight,
          ornament?.deduction,
          ornament?.netWeight,
          ornament?.netWeightWith22k,
          ornament?.sourceOfOwnership,
        ];
        if (productType === loanTypes?.diamondLoan) {
          row.push(
            ornament?.caretColor || " ",
            ornament?.caretGrade || " ",
            ornament?.diamondRate || " ",
            ornament?.diamondCaret || " ",
            Number(ornament?.diamondRate) * Number(ornament?.diamondCaret) || " "
          );
        }
        row.push(
          packetSizeName?.[0]?.name || ornament?.packetSize || " ",
          ornament?.packetNumber || " ",
          ornament?.packetSealNumber || " ",
          ornament?.ornamentPhotoLink
            ? getImageLink(index, ornament?.ornamentPhotoLink)
            : " ",
          statuses && ornamentNewJourney
            ? getActionLink(ornament, index, data)
            : ""
        );

        reportData.push(row);
      });

    const extraRow = [
      "NA",
      "TOTAL",
      "NA",
      "NA",
      calculateTotal("grossWeight", data),
      calculateTotal("stoneWeight", data),
      calculateTotal("deduction", data),
      calculateTotal("netWeight", data),
      calculateTotal("netWeightWith22k", data),
      "NA",
      "NA",
    ];

    if (productType === loanTypes?.diamondLoan) {
      extraRow.push("NA", "NA", "NA", "NA", "NA");
    }

    extraRow.push("NA", "NA", "NA", "NA", "");

    reportData.push(extraRow);
    setTableData(reportData);
  };
const calculateTotal = (field, data) => {
  const total = data.reduce((sum, ornament) => sum + (Number(ornament[field]) || 0), 0);
  return `${Number(total.toFixed(2))} gm`;
};

  const calculateEligibleLoanAmountApi = async (data) => {
    console.log(data,productType,"fshjdfbks")
    const goldData = data.map((item) => ({
      particulars: item.particulars || "",
      itemCount: item.itemCount ? Number(item.itemCount) : 0,
      finnesseCode: item.finnesseCode || "18k",
      grossWeight: item.grossWeight || 0,
      stoneWeight: item.stoneWeight || "",
      deduction: item.deduction || 0,
      packetNumber: item.packetNumber || "",
      sourceOfOwnership: item.sourceOfOwnership || "",
      ornamentType: item.ornamentType,
      ...(productType === loanTypes?.diamondLoan
        ? {
            caretColor: item?.caretColor || "",
            caretGrade: item?.caretGrade || "",
            diamondRate: item?.diamondRate || "",
            diamondCaret: item?.diamondCaret || "",
          }
        : {}),
    }));

    const result = await apiHandler({
      url: endpoint.ADMIN_CALCULATE_ELIGIBLE_AMOUNT_ALL_PRODUCTS,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicatonId:loanApplicationId,
        ornamentDetails: goldData,
      },
    });
    const eligibleAmount = Number(
    result?.data?.eligibleLoanAmt || 0
  );

    setEligibleLoanAmount(eligibleAmount.toFixed(2));
  };

  const handleNext = () => {
    setNext();
  };


  const addNextRow = async (updatedArray) => {
    let newIndex = lastIndex + 1;
    setLastIndex(newIndex);
    const ornamentDetails = (updatedArray || groupDetails).map((item) => ({
      ...item,
      ornamentType,
    }));
    if (ornamentDetails.length > 0) {
      calculateEligibleLoanAmountApi(ornamentDetails);
      parseIndicatorData(ornamentDetails, newOrnamentsToggle);
      updateTotalValues(ornamentDetails);
    }
    let newArr = [...ornamentDetails];
    newArr[newIndex] = {
      ornamentType,
      collateralType:"",
      particulars: "",
      finnesseCode: "",
      ratePerGram: "",
      grossWeight: "",
      stoneWeight: "",
      deduction: "",
      netWeight: "",
      netWeightWith22k: "",
      // tareWeight: "",
      caretGrade:"",
      caretColor:"",
      diamondRate:"",
      diamondCaret:"",
      diamondAmount:"",
      itemCount: "",
      packetNumber: "",
      eligibleLoanAmt: "",
      sourceOfOwnership: "",
      packetSize: "",
      packetWeight: "",
      packetSealed: true,
      disabledField: true,
      availablePacketNumber: [],
      tareWeight: "",
      ornamentPhotoLink: "",
      packetSealNumber: "1",
      particularsError: false,
      finnesseCodeError: false,
      countError: false,
      grossWeightError: false,
      stoneWeightError: false,
      deductionError: false,
      sourceOfOwnershipError: false,
      packetNumberError: false,
      packetSealNumberError: false,
      existingOrnament: !newOrnamentsToggle,
      additionalInfo: {
        disableExistingFields: false,
        ornamentUpdated: false,
      }
    };
    setGroupDetails(newArr);

    let newOrnamentArray = [...ornamentValues];
    newOrnamentArray[newIndex] = {
      count: "",
      minGrossWeight: "",
      maxGrossWeight: "",
      deduction: "",
    };
    setOrnamentValue(newOrnamentArray);
    setShowOrnamentTableModal(true);
  };
  const getGoldRate = async (finnesseCode, index) => {
    setCallInProgress(true);
    const apiPath = productType === loanTypes?.silverLoan ? endpoint.ADMIN_SILVERRATEFIND + `_${finnesseCode}` : endpoint.ADMIN_GOLDRATEFIND + finnesseCode;
    const goldRate = await apiHandler({
      url: apiPath,
      authToken: authToken,
    });
    setCallInProgress(false);
    let value = goldRate.data.lendingPrice;
    let newArr = [...groupDetails];
    let item = newArr[index];
    item = {
      ...item,
      finnesseCode: finnesseCode,
      ratePerGram: value,
      finnesseCodeError: false,
      grossWeight: "",
      deduction: "",
      stoneWeight: "",
      netWeight: "",
      netWeightWith22k: "",
      sourceOfOwnership: "",
      itemCount: "",
    };
    newArr[index] = item;
    setGroupDetails(newArr);
    handleCalculateWeight(index, newArr);
  };
  const getFinenessValue = (fineness) => {
    if (!fineness) return 0;
    return parseInt(fineness.replace(/\D/g, ""), 10) || 0;
  };

  const isChangeAllowed = (
    name,
    value,
    newArr,
    userDetails,
    loanType,
    subStatus,
    index
  ) => {
    const isRenewalFlow =
      loanType?.toUpperCase() === "RE_PLEDGE" &&
      ["TOP_UP", "RENEWAL"].includes(subStatus?.toUpperCase());
    const isBranchUser = userDetails?.rootHierarchy === false;

    if (!isRenewalFlow || !isBranchUser) {
      return { allowed: true, correctedValue: value };
    }

    switch (name) {
      case "finnesseCode": {
        const enteredValue = getFinenessValue(value);
        const maxAllowedValue = getFinenessValue(newArr[index]?.finnesseCode);

        if (enteredValue > maxAllowedValue) {
          toastUpdate(
            "Error",
            `Fineness code cannot be more than ${newArr[index]?.finnesseCode}`,
            true
          );
          return {
            allowed: false,
            correctedValue: newArr[index]?.finnesseCode,
          };
        }
        break;
      }
    }

    return { allowed: true, correctedValue: value };
  };

  const handleChange = (event, index, imageName, type) => {
    if (imageName) {
      Uploadcheque(event, index, imageName, type);
    } else {
      const name = event?.target?.name;
      let value = event?.target?.value;
      let newArr = [...groupDetails]; // copying the old data's array
      let item = newArr[index];
      let newNetAmount = 0;
      let newOrnamentArray = [...ornamentValues];
      let ornamentItem = newOrnamentArray[index];
      if(enabledValidationForRepledgeOrnament && isExistingRow(index)) {
        const { allowed, correctedValue } = isChangeAllowed(
          name,
          value,
          newArr,
          userDetails,
          loanType,
          subStatus,
          index
        );

        value = correctedValue;

        if (!allowed) {
          newArr[index] = { ...newArr[index], [name]: correctedValue };
          setGroupDetails(newArr);
          return;
        }
      }
      let isDuplicatePacketNumber = newArr
        .slice(0, index)
        .some((obj) => obj?.packetNumber === item?.packetNumber);
      if (event === "remove") {
        item = { ...item, ornamentPhotoLink: "" };
        setShowUpload(true);
      } else if (name === "particulars") {
        const ornamentValue = ornamentList.filter(
          (item) => item?.name === value
        );
        item = {
          ...item,
          [name]: value,
          collateralType: ornamentValue[0]?.collateralType,
          particulars: value,
          itemCount: "",
          grossWeight: "",
          deduction: "",
          stoneWeight: "",
          netWeight: "",
          netWeightWith22k: "",
          finnesseCode: "",
          ratePerGram: "",
          sourceOfOwnership: "",
          disabledField: false,
          particularsError: false,
        };
        ornamentItem = {
          ...ornamentItem,
          count: ornamentValue[0]?.maxAllowedCount,
          minGrossWeight: ornamentValue[0]?.minGrossWeight,
          maxGrossWeight: ornamentValue[0]?.maxGrossWeight,
        };
      } else if (name === "finnesseCode") {
        blurCompletedRef.current = true;
        getGoldRate(value, index);
      } else if (name === "stoneWeight") {
        blurCompletedRef.current = true;
        newNetAmount = Number((Number(item.grossWeight) - Number(value) ).toFixed(2));
        const regexValue = /^\d*\.?\d{0,2}$/.test(value);
        if (newNetAmount < 0) newNetAmount = 0;
        if (regexValue || value === "") {
          item = {
            ...item,
            [name]: value,
            netWeight: newNetAmount,
            stoneWeightError: false,
          };
        }
      } else if (name === "grossWeight") {
        blurCompletedRef.current = true;
        setGrossWeightChange(true);
        const regexValue = /^\d*\.?\d{0,2}$/.test(value);
        if (regexValue || value === "") {
          item = {
            ...item,
            [name]: value,
            netWeight: Number(value),
            tareWeight: isDuplicatePacketNumber
              ? Number(value)
              : Number(value) + item.packetWeight,
            deduction: "",
            stoneWeight: "",
            netWeightWith22k: "",
            sourceOfOwnership: "",
            grossWeightError: false,
          };
        }
      } else if (name === "itemCount") {
        blurCompletedRef.current = true;
        const regexValue = /^[1-9]\d*$/.test(value);
        if (regexValue || value === "") {
          item = {
            ...item,
            [name]: value,
            grossWeight: "",
            deduction: "",
            stoneWeight: "",
            netWeight: "",
            netWeightWith22k: "",
            sourceOfOwnership: "",
            countError: false,
          };
        }
      } else if (name === "deduction") {
        blurCompletedRef.current = true;
        const grossWeight = Number(item.grossWeight);
        const allowedPercentage = Number(allowDeductionPercentage);
        const maxAllowedDeduction = (grossWeight * allowedPercentage) / 100;
        if (Number(value) > maxAllowedDeduction) {
          toastUpdate(
            "Error",
            `Deduction should be less than ${allowedPercentage}% of gross weight`,
            true
          );
          setDeductionValue(true);
          setDisableNext(true);
        } else {
          setDeductionValue(false);
          setDisableNext(false);
        }
        newNetAmount =
          Number((
          Number(item.grossWeight) -
          Number(item.stoneWeight || 0) -
          Number(value)
        ).toFixed(2));
        if (newNetAmount < 0) newNetAmount = 0;
        const regexValue = /^\d*\.?\d{0,2}$/.test(value);
        if (regexValue || value === "") {
          item = {
            ...item,
            [name]: value,
            netWeight: newNetAmount,
            deductionError: false,
          };
        }
      } else if (name === "packetNumber") {
        const selectedPacketOption = item.availablePacketNumber?.find(
          (option) => String(option.value) === String(value)
        );
        const packetWeight = Number(
          selectedPacketOption?.weight ?? item.packetWeight
        ) || 0;
        const isDuplicatePacket = newArr.some(
          (otherItem, otherIndex) =>
            otherIndex !== index && otherItem.packetNumber === value
        );
        if (!isDuplicatePacket) {
          item.tareWeight = Number(item.grossWeight) + packetWeight;
        } else if (isDuplicatePacket) {
          item.tareWeight = Number(item.grossWeight);
        }
        item = {
          ...item,
          [name]: value,
          packetWeight,
          packetNumberError: false,
        };
      } else if (name === "packetSealed") {
        item = { ...item, [name]: event.target.checked };
      } else if (name === "SealNumber"){
        item = { ...item, packetSealNumber :  Number(value) , packetSealNumberError: false};
      }else if (name === "packetSize") {
        // item = { ...item, [name]: value };
        setChangeOrnamentData(true);
        getPacketNumbers(value, index, name);
      } else if (name === "sourceOfOwnership") {
        item = { ...item, [name]: value, sourceOfOwnershipError: false };
      } else if (name === "caretGrade"){
        item = { ...item, 
          [name] : value , 
          caretGradeError: false,
          diamondRate:""};
      } else if (name === "caretColor"){
        item = { ...item, [name] : value , caretColorError: false, diamondRate:""};
      } else if (name === "diamondRate"){
         item = { 
        ...item,
         diamondRate :  Number(value),
         diamondAmount: Number(value) * Number(item?.diamondCaret),
         diamondCaretError: false}
      } else if (name === "diamondCaret"){
        item = { 
        ...item,
         diamondCaret :  Number(value),
         diamondAmount: Number(value) * Number(item?.diamondRate),
         diamondCaretError: false}
      }else if (name !== "itemCount") {
        item = { ...item, [name]: value };
      }

      newArr[index] = item;
      newOrnamentArray[index] = ornamentItem;
      setGroupDetails(newArr);
      setOrnamentValue(newOrnamentArray);
            if(!notEligibleTopUpAccountType){
      setActualLoanAmount("");
            }
      setLtv("");
      setSchemeList([]);
      setTenure("");
      setMonthlyInterest("");
      setSelectedScheme("");
      setSelectedSchemeChannel("");
      setRevisedLoanAmount(null);
      setRevisedRoi(null);
    }
  };
  const updateOrnamentDetails = (event, index) => {
    const name = event.target.name;
    let value = event.target.value;
    let newArr = [...groupDetails]; // copying the old data's array
    let item = newArr[index];
    let newNetAmount = 0;
    if (name === "grossWeight") {
      newNetAmount = Number(value) - Number(item.deduction);
      if (newNetAmount < 0) newNetAmount = 0;
      item = {
        ...item,
        [name]: value,
        netWeight: newNetAmount,
        grossWeightError: false,
      };
    } else if (name === "deduction") {
      newNetAmount =
        Number(item.grossWeight) - Number(item.stoneWeight) - Number(value);
      if (newNetAmount < 0) newNetAmount = 0;
      item = {
        ...item,
        [name]: value,
        netWeight: newNetAmount,
        deductionError: false,
      };
    }
    item = { ...item, [name]: value };
    newArr[index] = item;
    handleCalculateWeight(index, newArr);
  };
  const onActualLoanAmount = async (text, eligibleAmount) => {
    if(Number(text) > Number(cashThreshHoldFlag) && enabledV2InprocessTab){
      setCallInProgress(true);
      const result = await apiHandler({
        url:
          endpoint.BANKINFORMATION_GETDATA +
          "?" +
          "applicationId=" +
          loanApplicationId,
        authToken: authToken,
      });
      setCallInProgress(false);
      if (result?.data?.error_code === 404) {
        toastUpdate("Error", `Actual loan amount cant be more than ${cashThreshHoldFlag}`, true);
        setActualLoanAmount("");
        return;
      }
    }
    if (Number(enabelPacketNumber) === 0) {
      setGroupDetails((prev) => normalizePacketAndOwnership(prev));
    }
    setActualLoanAmount(text);
    setRecalculateAmount(false);
    const isTopUpOrRenew =
      subStatus === repledgeCaseListName?.topUp ||
      subStatus === repledgeCaseListName?.renew;
    const prepledgeMapTotal = isTopUpOrRenew
      ? Object.values(updatedPrepledgeLoanMap || {}).reduce(
          (sum, amount) => sum + Number(amount || ZERO_VALUE),
          ZERO_VALUE
        )
      : Number(prepledgeLoanAmount || ZERO_VALUE);
    const totalAmount =
      Number(text || ZERO_VALUE) +
      Number(totalExposureAmount || ZERO_VALUE) -
      prepledgeMapTotal;
    if (
      totalAmount > Number(exposureAmountFlag) &&
      checkForExposureAmountFlag
    ) {
      toastUpdate(
        "Error",
        `You are eligible for ${
          Number(exposureAmountFlag) - totalExposureAmount
        } amount`,
        true
      );
      setActualLoanAmount("");
    } else if (+text >= +eligibleAmount * 1.05) {
      toastUpdate(
        "Error",
        "Actual Loan Amount has to be less than 1.05 times Eligible Amount",
        true
      );
      setActualLoanAmount("");
    } else if (text > Math.round((eligibleAmount * Number(maxLoanAmountPercentage)) / 100)) {
      toastUpdate(
        "Error",
        "Actual loan amount should not greather than max loan amount",
        true
      );
      setActualLoanAmount("");
    }else if (Number(text) < Math.round((eligibleAmount * Number(minLtvPercentage)) / 100) && groupDetails?.length > 1) {
      toastUpdate(
        "Error",
        "Actual loan amount should not be less than min loan amount",
        true
      );
      setActualLoanAmount("");
    }else {
      if (text.length > 3) {
        if (+text > PANCRITERIA) {
          // setShowPanDetails(true);
        }
      }
    }
    if(enabledCreditAssessmentOnLoanDetails || enabledLtvSchemeBased){
      const maxEligibleAmount = await getExposureAmount('returnFlag');
      if(Number(maxEligibleAmount) < Number(text)){
        toastUpdate("Error",`Actual loan amount can't be greater than ${maxEligibleAmount}`,true);
        return;
      }
    }
    setDisabledSchemeFields(false);
    getSchemeChannelList(authToken,toastUpdate , dispatch, saveSchemeChannel, setSchemeChannel);
    if (selectedSchemeChannel) {
      getEligibleInterest(
        selectedSchemeChannel,
        text,
        eligibleAmount,
        selectedSchemeName
      );
    }
  };
  useEffect(() => {
    if (selectedSchemeChannel && actualLoanAmount && statuses) {
      getEligibleInterest(
        selectedSchemeChannel,
        actualLoanAmount,
        eligibleLoanAmount,
        selectedSchemeName
      );
    }
  }, [selectedSchemeChannel, eligibleLoanAmount]);

  const getEligibleInterest = async (
    channelName,
    actualLoanAmount,
    eligibleAmount,
    schemeName,
    updatedLtv = false,
  ) => {
    const queryParams = new URLSearchParams({
      eligibleLoanAmt: eligibleAmount,
      actualLoanAmt: actualLoanAmount || 0,
      schemeChannel: channelName,
    });
    if (branchCodeSpecifiedSchemeFlag) {
      queryParams.append("branchCode", leadBranchCode || "");
    }
    if(getSchemeBaseOnLoanType){
      queryParams.append("applicationSubType", subStatus);
       const isNewCustomer = subStatus === APPLICATION_TYPE_New && newCustomer;
      queryParams.append("newCustomer", isNewCustomer)
    }

    const res = await apiHandler({
      url: `${
        endpoint.ADMIN_LOANSCHEME_CALCULATELTV
      }?${queryParams.toString()}`,
      authToken: authToken,
    });

    if (res?.data?.error_code === 404 || res?.data?.error_code) {
      setSchemeList([]);
      setSelectedScheme({});
      setTenure("");
      let ltvPercentage =
        (Number(actualLoanAmount) * 100) / Number(eligibleAmount);
      setLtv("" + ltvPercentage.toFixed(2));
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      if(updatedLtv){
        setUpdatedInterestLtv("" + res?.data && res?.data?.ltv?.toFixed(2));
        return;
      }
      const validSchemes = res?.data?.schemes ? res?.data?.schemes : [];
      let scheme = {};
      if (schemeName && schemeName !== "") {
        const validScheme = validSchemes.filter(
          (scheme) => scheme?.schemeName === schemeName
        );
        scheme = validScheme?.length > 0 ? validScheme[0] : {};
      } else {
        scheme = validSchemes?.length > 0 ? validSchemes[0] : {};
      }
      setLtv("" + res?.data && res?.data?.ltv?.toFixed(2));
      setSchemeList(validSchemes);
      setSelectedScheme(scheme);
      setMonthlyInterest((scheme && scheme?.monthlyInterest) || "");
      setTenure((scheme && scheme?.tenureInMonths) || "");
      setCrossCell(scheme?.data);
      if (scheme?.data?.CROSS_SELL) {
        setCrossSell(true);
      } else {
        setCrossSell(false);
      }
      setParseSchemeData(scheme);
    }
  };
  const calculateTotalWeight = (field, data) => {
    const total = data.reduce((sum, ornament) => sum + (Number(ornament[field]) || 0), 0);
    return Number(total.toFixed(2));
  };
  // submit pan info when he change the pan
  const conditionForPartReleaseChange = checkOrnamentUpdateForPartialRelease  && loanType === APPLICATION_TYPE_RE_PLEDGE && subStatus === repledgeCaseListName?.partRelease && !checkForAuditedFlagOrnamentFlag;
  const validatePartReleaseChange = (withReason) => {
    const oldOrnamentNetWeightWith22K = groupDetails
      .filter(item => item.additionalInfo?.disableExistingFields === true)
      .reduce((total, item) => total + Number(item?.netWeightWith22k || 0), 0);
     const deletedWeight = Number(originalTotalNetWeight22k) - Number(oldOrnamentNetWeightWith22K);
     const maxAllowedWeight =  Number(originalTotalNetWeight22k) + Number(netWeightUnacceptableItem) + Number(deletedWeight) * 0.01;
      const totalNetWeight22k = calculateTotalWeight('netWeightWith22k', groupDetails);
     if (Number(totalNetWeight22k) > maxAllowedWeight) {
      return withReason
        ? { valid: false, error: "WEIGHT_EXCEEDED" }
        : false;
    }
    const isWeightValid = Number(totalNetWeight22k) <= maxAllowedWeight;

    const isLengthChanged =
      oldLoanDetailsData?.length !== groupDetails?.length;

    const getTotalCount = groupDetails?.reduce(
      (sum, item) => sum + Number(item?.itemCount || 0),
      0
    );

    const getTotalOriginalCount = oldLoanDetailsData?.reduce(
      (sum, item) => sum + Number(item?.itemCount || 0),
      0
    );

    const isCountChanged = getTotalCount !== getTotalOriginalCount;

    const isAnyOrnamentUpdated = groupDetails?.some(
      (ornament) => ornament?.additionalInfo?.ornamentUpdated === true
    );
    
    const isValid =
      isWeightValid &&
      (isLengthChanged ||
        isCountChanged ||
        (!isLengthChanged && !isCountChanged && isAnyOrnamentUpdated));

    if (!isValid) {
      return withReason
        ? { valid: false, error: "NO_CHANGE" }
        : false;
    }

    return withReason ? { valid: true } : true;
  };
  const validateInputFields = () => {
    if(enabledPacketChangeInRenewalModal && loanType === APPLICATION_TYPE_RE_PLEDGE && subStatus === repledgeCaseListName?.topUp && groupDetailsOriginal?.length >= groupDetails?.length && newOrnamentsToggle){
      return {
      valid: false,
      message: "Please add another ornament or continue with the existing packet."
    };
    }
     if(conditionForPartReleaseChange){
      if (!validatePartReleaseChange()) {
        return {
          valid: false,
          message: "Please update part release details"
        };
      }
    }
    if (actualLoanAmount === "") {
      setActualLoanAmountState(true);
    } else {
      setActualLoanAmountState(false);
    }
    if (selectedSchemeChannel === "") {
      setSchemeChannelState(true);
    } else {
      setSchemeChannelState(false);
    }
    if (
      selectedScheme === "" ||
      typeof selectedScheme === "undefined" ||
      selectedScheme === null ||
      Object.keys(selectedScheme).length === 0
    ) {
      setParentTypeState(true);
    } else {
      setParentTypeState(false);
    }
    if (referral === "") {
      setReferalError(true);
    } else {
      setReferalError(false);
    }
    if (
      (referral === "Internal" ||
        referral === "Digital_Marketing" ||
        referral === "Existing_Customer") &&
      referralName === ""
    ) {
      setreferralNameError(true);
    } else {
      setreferralNameError(false);
    }
    if (
      referral === "Existing_Customer" &&
      referralContact === "" &&
      referralContact?.length < 10
    ) {
      setReferralContactError(true);
    } else {
      setReferralContactError(false);
    }
    if (referral === "Existing_Customer" && referralAccount === "") {
      setreferralAccountError(true);
    } else {
      setreferralAccountError(false);
    }
    if (groupDetails && Array.isArray(groupDetails)) {
      const allCountExists = groupDetails.every(
        (g) =>
          g.itemCount !== "" &&
          g.itemCount !== null &&
          g.itemCount !== undefined
      );
      const sourceOfOwnership = groupDetails.every(
        (g) =>
          g.sourceOfOwnership !== "" &&
          g.sourceOfOwnership !== null &&
          g.sourceOfOwnership !== undefined
      );
      const particulars = groupDetails.every(
        (g) =>
          g.particulars !== "" &&
          g.particulars !== null &&
          g.packetNumber !== undefined
      );
      const allPacketExists = groupDetails.every(
        (g) =>
          g.packetNumber !== "" &&
          g.packetNumber !== null &&
          g.packetNumber !== undefined
      );
      const stoneWeightExists = groupDetails.every(
        (g) =>
          g.stoneWeight !== "" &&
          g.stoneWeight !== null &&
          g.stoneWeight !== undefined
      );
      const deductionExists = groupDetails.every(
        (g) =>
          g.deduction !== "" &&
          g.deduction !== null &&
          g.deduction !== undefined
      );
      const netWeightExists = groupDetails.every(
        (g) =>
          g.netWeight !== "" &&
          g.netWeight !== null &&
          g.netWeight !== undefined
      );
      const grossWeightExists = groupDetails.every(
        (g) =>
          g.grossWeight !== "" &&
          g.grossWeight !== null &&
          g.grossWeight !== undefined
      );
      const packetSealNumberExists = groupDetails.every(
        (g) =>
          g.packetSealNumber !== "" &&
          g.packetSealNumber !== null &&
          g.packetSealNumber !== undefined
      );
      if (!particulars) {
         return { valid: false, message: "Please Select the particulars" };
      }
      if (!allCountExists) {
         return { valid: false, message: "Please Select Count" };
      }
      if (!grossWeightExists) {
         return { valid: false, message: "Please Select the Gross weight" };
      }
      if (!stoneWeightExists) {
        return { valid: false, message: "Please Select the stone weight" };
      }
      if (!deductionExists) {
        return { valid: false, message: "Please Select the deduction" };

      }
      if (!netWeightExists) {
        return { valid: false, message: "Please Select the net weight" };
      }
      if (!sourceOfOwnership) {
        return { valid: false, message: "Please Select Source Of Ownership" };
      }
      if (!allPacketExists) {
        setPacketError(true);
        return { valid: false, message: "Please Select Packet Number" };
        
      }
      if (!packetSealNumberExists) {
        setPacketError(true);
        return { valid: false, message: "Please Select Seal Number" };
      }
    }

    if (deductionValue) {
      return { valid: false, message: "Deduction should be less than 50% of gross weight" };
      
    }
    if (disableNext) {
      return { valid: false, message: "Please Provide the Loan complete Details"};
    }
    if (
      enabledUploadForm60Options &&
      Number(actualLoanAmount) < Number(loanAmountForFrom60) &&
      !form60Link
    ) {
      return {
        valid: false,
        message: "Please, uplaod the form 60",
      };
    }
    if(panAmountValidate(checkActualLoanAmountPerYear, actualLoanAmount,  PANCRITERIA, iflActualLoanAmount, YEARLYPANCRITERIA) && !firstTab ){
       if (
            panNumber !== "" &&
            typeof panNumber !== "undefined" &&
            panApplicantName !== "" &&
            typeof panApplicantName !== "undefined" &&
            panVerified === true
          ) {
            return { valid: true };
          } else {
            return {
              valid: false,
              message: "PAN verification required"
            };
          }
    } 
    if (
      actualLoanAmount !== "" &&
      groupDetails?.length > 0 &&
      Math.round(Number(totalNetWeight) * 100) <= Math.round(Number(totalTareWeight) * 100) && 
      selectedScheme !== null &&
      Object.keys(selectedScheme)?.length > 0 &&
      actualLoanAmount <= Math.round((eligibleLoanAmount * Number(maxLoanAmountPercentage)) / 100) &&
      selectedSchemeChannel &&
      !disableNext &&
      referral &&
      (((referral === "Internal" || referral === "Digital_Marketing") &&
        referralName) ||
        (!referralName && referral === "Direct") ||
        (referral === "Existing_Customer" &&
          referralAccount &&
          referralContact?.length === 10 &&
          referralName))
    ) {
      setPacketError(false);
      return { valid: true };
    } else {
       return {
    valid: false,
    message: "Please Provide the Loan complete Details"
  };
    }
  };
  const updatedPrePladgeMap = async () => {
    const result = await apiHandler({
      url: endpoint.UPDATED_LEAD_LOAN_APPLICATION + loanApplicationId,
      method: "PUT",
      authToken: authToken,
      data: {
        prePledgeLoanMap: updatedPrepledgeLoanMap,
      }
    });
    if(result?.data?.error_code){
      toastUpdate("Error", result?.data?.user_description, true);
      return false;
    }
    return true;
  };
  const criffEnabledAmount = Number(totalOutstandingAmount || 0) +  Number(actualLoanAmount || 0) + (selectedScheme?.data?.IS_BULLET ? Number(exposureData?.currentLoanFutureInterest) : 0 );
  const handleCreateOrnamentSubmit = async () => {
    const netWeightCheck = validateNetWeightPercentage(
      groupDetails,
      minNetWeightValue
    );
    const totalAmount = Number(actualLoanAmount) + Number(exposureData?.currentLoanFutureInterest);
    const maxAmount = Math.round((eligibleLoanAmount * Number(maxLoanAmountPercentage)) / 100);
    if(enabledApiBasedLtv && loanType?.toUpperCase() === "RE_PLEDGE"){
      const updatedData = await updatedPrePladgeMap();
      if(!updatedData){
        return;
      }
    }
    if(enabledCreditAssessmentOnLoanDetails && Number(criffEnabledAmount) > 250000 && !criffCalled){
      toastUpdate(
        "Error",
        `Please call the credit score`,
        true
      );
      return;
    }
    if(enabledCreditAssessmentOnLoanDetails && totalAmount > maxAmount ){
      setConfirmationModalHeader("Risk Warning");
      setConfirmationModalMsg(
        `Requested amount (${totalAmount}) exceeds the maximum allowed amount (${maxAmount}).`
      );
      setConfirmationModal(true);
      return;
    }
    if(enabledCreditAssessmentOnLoanDetails && (Number(actualLoanAmount) + Number(totalCurrentLoanInterestAmount || 0)) > Number(allowedOutFlowValue) && Number(criffEnabledAmount) > 250000){
      toastUpdate(
        "Error",
        `outflow cannot exceed ${formatAmount(allowedOutFlowValue)}`,
        true
      );
      return;
    }
    if(parseAndSetFlag(featureFlags?.showCollateralType)){
      const collateralTypeValidation = await checkCollateralType(customerId, authToken, groupDetails, setCallInProgress, toastUpdate, mobileNum);
      if(!collateralTypeValidation){
        return false
      }
    }
   const maxLoan =
    (Number(eligibleLoanAmount) * Number(selectedScheme?.maximumLtvPercentage)) /
    100;

  if (selectSchemeModal && Number(revisedLoanAmount) > maxLoan) {
    toastUpdate(
      "Error",
      `Revised Loan Amount can't exceed ${maxLoan.toFixed(2)}`,
      true
    );
    return;
  }
    if (!netWeightCheck.valid && enabledLeadValidateForNewLoan) {
      toastUpdate(
        "Error",
        `Net weight of ${
          netWeightCheck.particulars || "ornament"
        } cannot exceed ${minNetWeightValue}% of gross weight`,
        true
      );
      return;
    }   

    const result = validateInputFields();
    if(parseAndSetFlag(featureFlags?.enabledCreditAssessmentOnLoanDetails)){
      const creditAssessmentResult = await handleAddCreditAssessmentData();
      if (!creditAssessmentResult) {
        return;
      }
    }
    if (result.valid) {
        if (editable && getOrnamentData && changeOrnamentData) {
          UnAssignPacketNumber();
        } else if (editable && !getOrnamentData) {
          handlePacketAssigned();
        } else {
            handleAddData();
        }
    } else {
      let errMsg = "Please Provide the Loan complete Details";
      if (totalTareWeight < totalNetWeight) {
        errMsg =
          "Tare Weight should always be greater than the Total Net weight of the ornaments";
      }
      if (deductionValue) {
        errMsg = "Deduction should be less than 50% of gross weight";
      }
      if (actualLoanAmount > Math.round((eligibleLoanAmount * Number(maxLoanAmountPercentage)) / 100)) {
        errMsg = "Actual loan amount should not greater than max loan amount";
      }
      if(enabledPacketChangeInRenewalModal && loanType === "RE_PLEDGE" && subStatus === "TOP_UP" && newOrnamentsToggle && groupDetailsOriginal?.length >= groupDetails?.length){
        toastUpdate("Error","Please add another ornament or continue with the existing packet.",true);
        return;
      }
      if (conditionForPartReleaseChange) {
          const result = validatePartReleaseChange(true);
          if (!result.valid) {
            if (result.error === "WEIGHT_EXCEEDED") {
              toastUpdate("Error", "Additional ornaments 22k netweight cannot exceed 101% of released ornaments 22k netWeight.", true);
            } else {
              toastUpdate("Error", "Please update at least one ornament detail to proceed.", true);
            };
            return false;
          }
      }
      if(result?.message){
        errMsg = result.message;
      }
      toastUpdate("Error", errMsg, true);
    }
  };
  const fixNetWeightWith22k = async () => {
    if (!Array.isArray(groupDetails) || groupDetails?.length === 0) {
      return groupDetails;
    }
    const updatedDetails = [...groupDetails];
    for (let index = 0; index < updatedDetails?.length; index++) {
      const item = updatedDetails[index];
      const netWeight = parseFloat(item?.netWeight);
      const netWeightWith22k = parseFloat(item?.netWeightWith22k);
      if (isNaN(netWeight) || isNaN(netWeightWith22k)) continue;
      if (netWeightWith22k > netWeight) {
        try {
          let payloadData = {}
            if(productType === loanTypes?.silverLoan ){
              payloadData = {
                netWeight: netWeight,
                netWeightPurity: item?.finnesseCode,
                expectedNetWeightPurity: "999",
                productType:productType,
              }
            }else{
              payloadData = {
                netWeight: netWeight,
                netWeightGoldPurity: item?.finnesseCode,
                expectedNetWeightGoldPurity: "22k",
                productType:productType,
              }
            }
          const result = await apiHandler({
            url: calculateWeightApiPath,
            method: "POST",
            authToken,
            data: payloadData,
          });
          updatedDetails[index] = {
            ...item,
            netWeightWith22k: Number(
              result?.data?.netWeight ?? netWeight
            ),
          };
        } catch (error) {
          console.error(
            `Failed to recalculate 22k weight for ${item?.particulars}`,
            error
          );
        }
    }
  }
  return updatedDetails;
  };
  const handleAddData = async (event) => {
    setCallInProgress(true);
      const updatedList = await fixNetWeightWith22k();
     const newArray = updatedList.map(item => {
      const copy = { ...item };
      delete copy.grossWeightError;
      delete copy.countError;
      delete copy.availablePacketNumber;
      delete copy.particularsError;
      delete copy.finnesseCodeError;
      delete copy.stoneWeightError;
      delete copy.deductionError;
      delete copy.sourceOfOwnershipError;
      delete copy.packetNumberError;
      delete copy.packetSealNumberError;
      !parseAndSetFlag(featureFlags?.showCollateralType) && delete copy.collateralType;
      copy.eligibleLoanAmt = "";
      return copy;
    });
    const revisedMinLoanAmt =
      revisedLoanAmount != null
        ? Number(revisedLoanAmount) < Number(selectedScheme?.minLoanAmount)
            ? Number(revisedLoanAmount)
            : Number(selectedScheme?.minLoanAmount)
        : null;

    const revisedMaxLoanAmt =
      revisedLoanAmount != null
        ? Number(revisedLoanAmount) > Number(selectedScheme?.maxLoanAmount)
            ? Number(revisedLoanAmount)
            : Number(selectedScheme?.maxLoanAmount)
        : null;    
      const baseLoanAmount =  actualLoanAmount && actualLoanAmount !== "" ? Number(actualLoanAmount) : 0;
      const finalAmount = notEligibleTopUpAccountType ? baseLoanAmount + (addChargeChange ? Number(totalChargeAmount) : 0): baseLoanAmount;

    const res = await apiHandler({
      url: endpoint.ADMIN_ORNAMENT_CREATE,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        loanApplicationNumber: loanApplicationNumber,
        actualLoanAmount:finalAmount,
        ltv: enabledCreditAssessmentOnLoanDetails ? updatedInterestLtv : ltv && ltv !== "" ? ltv : null,
        ornamentDetails: newArray?.filter(
          (group) => group.finnesseCode !== "" && group.ratePerGram !== ""
        ),
        packetNumber: rawData?.packetNumber ? rawData?.packetNumber : null,
        packetSize: "",
        loanSchemeId: selectedScheme.id,
        tenureInMonths: tenure && tenure !== "" ? tenure : null,
        tareWeight:
          !ornamentGetData || getOrnamentDataLength < groupDetails?.length
            ? Number(totalTareWeight) + Number(addDefaultTareWeight)
            : Number(totalTareWeight),
        remarks: remarks,
        referral: referral,
        referralName: referralName,
        referralLoan: referralAccount,
        referralContact: referralContact,
        packetSealed: true,
        externalLoanAmt:
          crossCell?.CROSS_SELL === true ? personalLoanElegiblityAmount : "",
        revisedLoanAmt: revisedLoanAmount || null,
        revisedAnnualRoi: revisedRoi || null,
        revisedMinLoanAmt: revisedMinLoanAmt,
        revisedMaxLoanAmt: revisedMaxLoanAmt,
        totalChargeAmt:totalChargeAmount,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code && res?.data?.error_code === 403) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else {
      toastUpdate("Success", "Create Ornament successfully", true);
      setNext("getDetails");
    }
  };
  const updateTareWeight = (newArr) => {
    setPacketSizeUpdate(false);
    let totalPacketWeight = 0;
    const packetNumbersAdded = new Set();
    const updatedGroupDetails = newArr.map((item) => {
      if (!packetNumbersAdded.has(item.packetNumber)) {
        totalPacketWeight += item.packetWeight;
        packetNumbersAdded.add(item.packetNumber);
      }
      
      return {
        ...item,
        packetNumber: "",
        packetSize: "",
        tareWeight: item.grossWeight,
      };
    });
    setTotalTareWeight(
      Number(totalTareWeight) -
        Number(totalPacketWeight) -
        (!grossWeightChange ? Number(addDefaultTareWeight) : 0)
    );
    setGroupDetails(updatedGroupDetails);
  };
  const UnAssignPacketNumber = async (noPacketAssign) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.UNASSIGN_PACKETS,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
      },
    });
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      setCallInProgress(false);
      return false;
    } else {
      if(noPacketAssign !== 'noPacketAssign'){
        return await handlePacketAssigned(true);
      }
      setCallInProgress(false);
      return true;
    }
  };

  const handlePacketAssigned = async (isRetry = false) => {
    const uniquePacketNumbers = new Set();
    const newArray = [];

    groupDetails.forEach((item) => {
      const { packetNumber, packetSize } = item;
      if (!uniquePacketNumbers.has(packetNumber)) {
        uniquePacketNumbers.add(packetNumber);
        newArray.push({ number: packetNumber, size: packetSize });
      }
    });
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.PACKET_ASSIGNED,
      method: "POST",
      authToken: authToken,
      data: {
        branchCode: leadBranchCode,
        loanApplicationId: loanApplicationId,
        packets: newArray,
        reassigned: !newOrnamentsToggle
      },
    });
    if (res?.data?.error_code) {
        if (
        res?.data?.error_code === 409 &&
        res?.data?.user_description === PACKET_ALREADY_ASSIGNED &&
        !isRetry
      ) {
        return await UnAssignPacketNumber();
      }
      toastUpdate("Error", res?.data?.user_description, true);
      setCallInProgress(false);
      return false;
    } else {
        handleAddData();
    }
  };
  const applyScheme = (val) => {
  setSelectedScheme(val);
  setLoanSchemeCode(val?.schemeCode);
  setParseSchemeData(val);
  setCrossCell(val?.data);
  setRevisedLoanAmount(null);
  setRevisedRoi(null);
  setMonthlyInterest(val?.monthlyInterest);
  setTenure(val?.tenureInMonths);
  calculateTotalTareWeight(groupDetails , setTotalTareWeight);
  if (notEligibleTopUpAccountType) {
    if (Number(enabelPacketNumber) === 0) {
      setGroupDetails((prev) => normalizePacketAndOwnership(prev));
    }

    getProcessingFeeApi(
      authToken,
      val?.id,
      toastUpdate,
      leadBranchCode,
      setChargeData,
      setTotalChargeAmount,
      setCallInProgress,
      prePledgeLoan,
      setAddChargeChange,
      setActualLoanAmount,
      notEligibleTopUpAccountType,
      closureTimePayableAdjust,
      closureTimeExceedAmount,
      loanApplicationId
    );
  }

  setCrossSell(!!val?.data?.CROSS_SELL);
};
  const onHandleSelected = (val) => {
    if (val?.data?.IS_BULLET) {
      setTempSelectedScheme(val);
      setConfirmationModalBulletScheme(true);
      setConfirmationModalHeaderBulletScheme("Scheme");
      setConfirmationModalMsgBulletScheme(
        "This is a bullet scheme. Future interest will be added to the actual loan amount."
      );
      return;
    }
    previousSchemeRef.current = selectedScheme;

    applyScheme(val);
  };
  const CloseLoanSchemeModal = () => {
    setShowModal(false);
  };
  const closeViewImageModal = () => {
    setViewImageModal(!viewImageModal);
  };
  const selectedSchemeArary = schemeList.filter(
    (item) => item.schemeName === selectedScheme.schemeName
  );
  const addButtonEnable =
    groupDetails?.length &&
    groupDetails.every((item) => {
      const baseCheck =
        item.fineeseCode !== "" &&
        item.ratePerGram !== "" &&
        item.grossWeight !== "" &&
        item.stoneWeight !== "" &&
        item.sourceOfOwnership !== "";
      if (Number(enabelPacketNumber) !== 0) {
        return (
          baseCheck && item.packetNumber !== "" && item.packetSealNumber !== ""
        );
      }
      return baseCheck;
    });
  const handleChangeContact = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setReferralContact(e);
    }
  };

  const referalSet = (e) => {
    setReferral(e);
    setReferralAccount("");
    setReferralContact("");
    setreferralName("");
  };

  const checkTotalTareWeight = (e) => {
    let totalTareWeight = 0;
    groupDetails.forEach((item) => {
      totalTareWeight += item.tareWeight;
    });
    if (e < totalTareWeight) {
      toastUpdate(
        "Error",
        `Total tare weight can't be less than ${totalTareWeight}`,
        true
      );
      setDisableNext(true);
    } else {
      setDisableNext(false);
    }
  };
  const Uploadcheque = async (file, index, imageName, type) => {
    if (file) {
      const formData = new FormData();
      const fileName = type ? "" : removeSpecialCharFileName(file.name);
      type
        ? formData.append("file", file, type)
        : formData.append("file", file, fileName);
      setCallInProgress(true);
      const path = await apiHandler({
        url: endpoint.FILE_UPLOAD,
        method: "POST",
        authToken: authToken,
        data: formData,
      });
      setCallInProgress(false);
      if (path.data.errorCode) {
        toastUpdate("Error", path?.data?.user_description, true);
      } else {
        let newArr = [...groupDetails]; // copying the old data's array
        let item = newArr[index];
        const uploadedPath = path.data;
        item = { ...item, [imageName]: uploadedPath?.name?.trim() };
        newArr[index] = item;
        setGroupDetails(newArr);
      }
    } else {
      toastUpdate("Error", "Upload Document", true);
    }
  };
  const showImageFunction = (index, imageUrl) => {
    setImageUrl(imageUrl);
    setViewImageModal(!viewImageModal);
  };
  const updateTotalValues = (updatedList) => {
    if (
      updatedList?.length <= getOrnamentDataLength
    ) {
      setOrnamentGetData(true);
    } else {
      setOrnamentGetData(false);
    }

    const totalTareWeight = updatedList.reduce((sum, item) => sum + Number(item.tareWeight), 0);
    const totalGrossWeight = updatedList.reduce((sum, item) => sum + Number(item.grossWeight), 0);
    const totalNewWeight = updatedList.reduce((sum, item) => sum + Number(item.netWeight), 0);
    setTotalTareWeight(totalTareWeight);
    setTotalGrossWeight(totalGrossWeight);
    setTotalNetWeight(totalNewWeight?.toFixed(2));
  }
  const closeOrnamentTableModal = (updatedList) => {
    setShowOrnamentTableModal(!showOrnamentTableModal);
    calculateEligibleLoanAmountApi(updatedList)
    parseIndicatorData(updatedList,newOrnamentsToggle);
    updateTotalValues(updatedList);
    setEditIndex('');
  };
  const handleSchemeModal = (code) => {
    if(code){
    setLoanSchemeCode(code)
    }
    setShowModal(!showModal);
  }
 const handleChangeToogle = async () => {
  const nextValue = !newOrnamentsToggle;

  if (nextValue === true) {
    const ok = await checkCollateralMovement();
    if (!ok) return;
  }
  setNewOrnamentsToggle(nextValue);
  updateData(existingLoanData?.ornamentDetails, false, nextValue);

};
  const checkCollateralMovement = async () => {
    setCallInProgress(true);
    const outstandingresult = await apiHandler({
      url:endpoint.CHECK_LOAN_STATUS + "?loanAccountNumber=" + prePledgeLoan,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if(outstandingresult?.data?.collateralLoacation !== collateralOperationStatus?.inBranch && outstandingresult?.data?.collateralLoacation !== collateralOperationStatus?.receivedFromHO){
      toastUpdate("Error","Requested loan collateral is not in branch",true);
      setNewOrnamentsToggle(false);
      return false;
    }
    return true;
  }
  const hideAddButtonOnRenewal = disableExistingOrnamentFields && loanType === "RE_PLEDGE" && subStatus === "RENEWAL";

  const mainCondition =
    (checkForAuditedFlagOrnamentFlag &&
      loanType === "RE_PLEDGE" &&
      (!userDetails?.rootHierarchy &&
        subStatus === repledgeCaseListName?.topUp)) ||
    !checkForAuditedFlagOrnamentFlag ||
    loanType !== "RE_PLEDGE";
  const handleBlurAnnualIncome = (e) => {
    const value = Number(e);
    if(value < Number(annualIncomeAmount)){
      toastUpdate("Error", `Cash Inflow is not sufficient`, true);
      return;
    }
    setAnnualIncome(value);
  };
 const totalInFlowIncome =
  Number(annualIncome || 0) +
  additionalIncomeList.reduce(
    (sum, item) => sum + Number(item.additionalIncome || 0),
    0
  );
    const foirRule = foirConfig?.find(
      ({ minLoanAmount, maxLoanAmount }) =>
        totalInFlowIncome >= Number(minLoanAmount) &&
        totalInFlowIncome <= Number(maxLoanAmount)
    );
  const getLoanArray = prePledgeLoan ? exposureData?.loans?.filter(item => item.loanAccountNumber !== prePledgeLoan) : exposureData.loans;
  const foirValueAmount = Math.round(
    (Number(totalInFlowIncome || 0) * Number(foirRule?.foirPercentage || 0)) / 100
  );

  const allowedOutFlowValue = Math.round(
    ((foirValueAmount - Number(otherEmi || 0)) * 12 * 5) -
      Number(totalOutstandingAmount || 0)
  );
  

  useEffect(() => {
  if(enabledApiBasedLtv && Number(eligibleLoanAmount) > 0 && selectedScheme?.schemeCode){
      checkSchemeEligibility("checkAmount");
    }
  },[eligibleLoanAmount,selectedScheme,enabledApiBasedLtv])

  const checkSchemeEligibility = async () => {
    console.log("checkSchemeEligibility called",selectedScheme,eligibleLoanAmount,actualLoanAmount);
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_LOAN_ELIGIBLITY_DETAILS,
      method: "POST",
      authToken: authToken,
      data: {
        mobileNumber: mobileNum,
        newLoanCollateralValue: Math.round(eligibleLoanAmount),
        newLoanAmount: actualLoanAmount || 0,
        newLoanLtv: selectedScheme?.ltv || 0,
        ...(subStatus !== APPLICATION_TYPE_New && {
          adjustedLoanAccountNumbers:
            updatedPrepledgeLoanMap &&
            typeof updatedPrepledgeLoanMap === "object" &&
            !Array.isArray(updatedPrepledgeLoanMap)
              ? Object.keys(updatedPrepledgeLoanMap)
              : prePledgeLoan
                ? [prePledgeLoan]
                : [],
        }),
      },
    });
    setCallInProgress(false);
    if(result?.data?.error_code){
      toastUpdate("Error",result?.data?.user_description,true);
      if (previousSchemeRef.current) {
        setSelectedScheme(previousSchemeRef.current);
      }
      return;
    }else{
      if(Number(selectedScheme?.ltv) >= 80){
      //check if lonaDAta have any penfing outstanding interest
        // if (loanData?.length > 0) {
        //   const pendingOutstandingInterest = loanData.some(
        //     (loan) => Number(loan?.outstandingInterest || 0) + Number(loan?.accuralInterest || 0) > 0
        //   );
        //   if (pendingOutstandingInterest) {
        //     setActualLoanAmount("");
        //     setSelectedScheme({});
        //     setSchemeChannel("");
        //     toastUpdate(
        //       "Error",
        //       "You have pending outstanding interest on your existing loan. Please clear it before proceeding.",
        //       true
        //     );
        //     return;
        //   }
        // }
        const prepledgeLoanCount = Object.keys(updatedPrepledgeLoanMap || {}).length;
        const apiLoanCount = result?.data?.loans?.length || 0;
        if (apiLoanCount > 0) {
          setActualLoanAmount("");
          setSelectedScheme({});
          setSchemeChannel("");
          toastUpdate(
            "Error",
            "Please close all the loans before proceeding with the new loan application.",
            true
          );
          return;
        }
        previousSchemeRef.current = selectedScheme;
      }
    }
  };
  useEffect(() => {
  if((enabledCreditAssessmentOnLoanDetails || enabledLtvSchemeBased) && Number(eligibleLoanAmount) > 0 && selectedScheme?.schemeCode){
      getExposureAmount("checkAmount");
    }
  },[eligibleLoanAmount,selectedScheme,enabledCreditAssessmentOnLoanDetails,enabledLtvSchemeBased])

  const getExposureAmount = async (flag) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.EXPOSURE_AMOUNT_GET,
      method: "POST",
      authToken: authToken,
      data: {
        customerId: customerId,
        mobileNumber: mobileNum,
        currentLoanOrnamentValue:eligibleLoanAmount,
        schemeCode:selectedScheme?.schemeCode,
        bulletScheme:selectedScheme?.data?.IS_BULLET ? true : false,
        currentLoanAmount: actualLoanAmount || 0,
        ...(subStatus !== APPLICATION_TYPE_New && {
          adjustedLoanAccountNumbers:
            updatedPrepledgeLoanMap &&
            typeof updatedPrepledgeLoanMap === "object" &&
            !Array.isArray(updatedPrepledgeLoanMap)
              ? Object.keys(updatedPrepledgeLoanMap)
              : prePledgeLoan
                ? [prePledgeLoan]
                : [],
        }),
      },
    });
    setCallInProgress(false);
    if(result?.data?.error_code){
      toastUpdate("Error",result?.data?.user_description,true);
    }else{
      const exposureDetailsTotalAmount = result?.data?.loans?.reduce(
        (total, loan) =>
          total +
          Number(loan?.principalAmount || 0) +
          Number(loan?.outstandingInterest || 0) +
          Number(loan?.outstandingCharges || 0) +
          (enabledLtvSchemeBased ? Number(loan?.futureInterest || 0) : 0),
        0
      );
      const exposureDetailsTotalAmountInterest = result?.data?.loans?.reduce(
          (total, loan) => total + Number(loan?.futureInterest || 0) ,
          0
        )
      setTotalOutstandingAmount(exposureDetailsTotalAmount);
      setTotalPreviousLoanInterestAmount(exposureDetailsTotalAmountInterest)
      setTotalCurrentLoanInterestAmount(result?.data?.currentLoanFutureInterest);
      setExposureData(result?.data);
      setMaxLoanAmountPercentage(result?.data?.applicableLtv);
      const updatedAmount = Math.round(
        Number(actualLoanAmount || 0) +
        Number(result?.data?.currentLoanFutureInterest || 0)
      );
      const ltvMaxAmount = Math.round(
        (Number(eligibleLoanAmount || 0) *
          Number(result?.data?.applicableLtv || 0)) / 100
      );
      setActualLoanAmountWithInterest(updatedAmount);
      if (updatedAmount > Number(result?.data?.maxLoanAmount || 0)) {
        toastUpdate(
          "Error",
          `Actual loan amount (${updatedAmount}) can't be greater than the maximum allowed amount (${Math.round(result?.data?.maxLoanAmount)}).`,
          true
        );
        setActualLoanAmount("");
        return;
      }
      if (updatedAmount > ltvMaxAmount) {
        toastUpdate(
          "Error",
          `Actual loan amount (${updatedAmount}) can't be greater than the LTV maximum amount (${Math.round(ltvMaxAmount)}).`,
          true
        );
        setActualLoanAmount("");
        return;
      }
      if(selectedSchemeChannel){
      await getEligibleInterest(
        selectedSchemeChannel,
        updatedAmount,
        eligibleLoanAmount,
        selectedSchemeName,
        true,
      );}
      if (flag === "returnFlag") {
        return result?.data?.maxLoanAmount;
      }
      if (flag === "checkAmount") {
        if (updatedAmount > Number(result?.data?.maxLoanAmount || 0)) {
          toastUpdate(
            "Error",
            `Actual loan amount can't be greater than ${result?.data?.maxLoanAmount}`,
            true
          );
          return;
        }
        if (updatedAmount > ltvMaxAmount) {
          toastUpdate(
            "Error",
            `Actual loan amount can't be greater than ${ltvMaxAmount}`,
            true
          );
          return;
        }
      }
    }
  }
  const getCreditScore = async () => {
    setCallInProgress(true)
    const res = await apiHandler({
      url: endpoint.GET_CREDIT_SCORE_AND_EMI + loanApplicationId,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false)
    if (res?.data?.error_code === 500 || res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      setCriffCalled(false);
    } else {
      setOtherEmi(res?.data?.existingMonthlyEmiObligation);
      setCreditScore(res?.data?.creditScore);
      setCriffCalled(true);
      await getCibilObligation();
    }
  }
  const getCibilObligation = async () => {
    setCallInProgress(true)
    const res = await apiHandler({
      url: endpoint.GET_CIBIL_OBILIGATION_DETAILS + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false)
    if (res?.data?.error_code === 500 || res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      setCibilObiligationsData(res?.data?.applicantCibilScoreDetail?.rawResponse?.data?.obligations);
    }
  }
  const totalOutflowAmt = Number(totalOutstandingAmount || 0) + Number(actualLoanAmount || 0) + Number(otherEmi) + Number(exposureData?.currentLoanFutureInterest || 0);
const handleAddCreditAssessmentData = async () => {
    setCallInProgress(true);
    const payload = {
      loanApplicationId,
      annualIncome,
      additionalDetails: additionalIncomeList
        ?.filter(
          (item) =>
            item.additionalSource &&
            Number(item.additionalIncome) > 0
        )
        ?.map((item) => ({
          name: item.additionalSource,
          amount: Number(item.additionalIncome),
          address: item?.address,
          attachment: item?.attachment,
          attachmentType:item?.attachmentType,
        })),
        totalOutstandingAmount:totalOutstandingAmount,
        prevLoanInterest:totalPreviousLoanInterestAmount,
        currentLoanInterest:Math.round(Number(totalCurrentLoanInterestAmount)),
        purposeOfLoan: meanPurposeOfLoan,
        dataMap:{
          foirValue:foirValueAmount,
          maxEligigbleAmount:allowedOutFlowValue,
        }
    };
    const response = await apiHandler({
      url: endpoint.CREDIT_ASSESSMENT_DATA_CREATE,
      authToken,
      method: "POST",
      data: payload,
    });
    setCallInProgress(false);
    if (response?.data?.error_code) {
      toastUpdate(
        "Error",
        response?.data?.user_description,
        true
      );
      return false;
    } else {
      return true;
    }
  };
  const closeConfirmationModal = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
  };
  
  const handleNegativeResponse = () => {
    closeConfirmationModal();
    setRecalculateAmount(true);
  };
  
  const handlePositiveResponse = () => {
    closeConfirmationModal();
    setRecalculateAmount(false);
  };
  const closeConfirmationModalBulletScheme = () => {
    setConfirmationModalBulletScheme(false);
    setConfirmationModalHeaderBulletScheme("");
    setConfirmationModalMsgBulletScheme("");
  };
  const handleNegativeResponseBulletScheme = () => {
    setConfirmationModalBulletScheme(false);
    setTempSelectedScheme(null);
  };
  
  const handlePositiveResponseBulletScheme = () => {
    setConfirmationModalBulletScheme(false);
    if (tempSelectedScheme) {
      applyScheme(tempSelectedScheme);
      setTempSelectedScheme(null);
    }
  };
  const refreshValue = async () => {
    const result = await loanEligibilityDetails(true);
    if (result?.data?.lenght > 0) {
      setActualLoanAmountWithInterest(
        Math.round(Number(actualLoanAmount || 0) + Number(exposureData?.currentLoanFutureInterest || 0))
      );
    }
  }
  const tableColumns = [
    ...nonEditableTableColumns.slice(0, 7),
    productType === loanTypes?.silverLoan
      ? "999 Eq Net Wt (Gm)"
      : nonEditableTableColumns[7],
    ...nonEditableTableColumns.slice(8, 9),
    ...(productType === loanTypes?.diamondLoan
      ? [
          "Caret Color",
          "Caret Grade",
          "Diamond Rate",
          "Diamond Caret",
          "Diamond Amount",
        ]
      : []),

    ...nonEditableTableColumns.slice(9),
  ];
  return (
    <div>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.mainHeader}>
        <SubHeader
          label={headerLabel?.ornament}
          subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
          onlyLabel
          toggleEnabled= {enabledPacketChangeInRenewalModal && loanType === "RE_PLEDGE" && subStatus !== "PART_RELEASE"}
          toggleValue= {newOrnamentsToggle}
          onToggleChange= {handleChangeToogle}
          toggleLabelLeft= "Same Collateral"
          toggleLabelRight= "Additional Collateral"
          toggleDisabled= {newOrnamentsToggleDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ margin: "0 2% 2%", width: "96%" }}
          >
            <TableContainer>
              <CustomTable
                tableHead={tableColumns}
                tableData={tableData}
                lastRowBold
              />
            </TableContainer>
          </Grid>
          {editable === true && (
            <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ display: "flex", margin: "0 2% 2%", justifyContent:'right' }}
            >
            {!hideAddButtonOnRenewal && mainCondition && newOrnamentsToggle && (
              <Button
                size="small"
                onClick={() => addNextRow()}
                // style={{ width: "125px" , backgroundColor:brandTheme.buttonColor,marginRight:'2%'}}
                className={classes.nextButton}
                disabled={groupDetails.length > 0 && !addButtonEnable}
              >
                Add
              </Button>
            )}
            {groupDetails?.length > 0 && (
              <Button
                size="small"
                // color="info"
                className={classes.nextButton1}
                onClick={() => calculateEligibleLoanAmountApi(groupDetails)}
              >
                calculate
              </Button>
              )}
            </Grid>
          )}
          <LoanDetails
            eligibleLoanAmount={eligibleLoanAmount}
            actualLoanAmount={actualLoanAmount}
            editable={editable} // true or false based on your state
            setActualLoanAmount={setActualLoanAmount}
            actualLoanAmountState={actualLoanAmountState}
            setActualLoanAmountState={setActualLoanAmountState}
            onActualLoanAmount={onActualLoanAmount}
            schemeList={schemeList}
            selectedScheme={selectedScheme}
            setSelectedScheme={setSelectedScheme}
            selectedSchemeName={selectedSchemeName}
            schemeChannelList={SchemeChannelData}
            selectedSchemeChannel={selectedSchemeChannel}
            setSelectedSchemeChannel={setSelectedSchemeChannel}
            schemeChannelState={schemeChannelState}
            setSchemeChannelState={setSchemeChannelState}
            referral={referral}
            referalSet={referalSet}
            referalError={referalError}
            setReferalError={setReferalError}
            referralName={referralName}
            setreferralName={setreferralName}
            referralNameError={referralNameError}
            referralContact={referralContact}
            handleChangeContact={handleChangeContact}
            referralContactError={referralContactError}
            referralAccount={referralAccount}
            setReferralAccount={setReferralAccount}
            referralAccountError={referralAccountError}
            monthlyInterest={monthlyInterest}
            tenure={tenure}
            ltv={ltv}
            personalLoanElegiblityAmount={personalLoanElegiblityAmount}
            crossCell={crossCell}
            status={status}
            parseSchemeData={parseSchemeData}
            showAdjustmentLoanDetailsFields={showAdjustmentLoanDetailsFields}
            classes={classes}
            SchemeChannelData={SchemeChannelData}
            parentTypeState={parentTypeState}
            setParentTypeState={setParentTypeState}
            onHandleSelected={onHandleSelected}
            referralNameList={referralNameList}
            setreferralNameError={setreferralNameError}
            setReferralContactError={setReferralContactError}
            setreferralAccountError={setreferralAccountError}
            handleSchemeModal={handleSchemeModal}
            totalTareWeight={totalTareWeight}
            totalCollateralValue={totalCollateralValue}
            prePledgeLoan={prePledgeLoan}
            loanType={loanType}
            maxLoanAmountPercentage={maxLoanAmountPercentage}
            firstTab={firstTab}
            panNumber={panNumber}
            setPanNumber={setPanNumber}
            panApplicantName={panApplicantName}
            setPanApplicantName={setPanApplicantName}
            panVerified={panVerified}
            setPanVerified={setPanVerified}
            setCallInProgress={setCallInProgress}
            toastUpdate={toastUpdate}
            authToken={authToken}
            setMeanPurposeOfLoan={setMeanPurposeOfLoan}
          loanApplicationId={loanApplicationId}
          mobileNum={mobileNum}
          featureFlag={featureFlags}
          revisedLoanAmount={revisedLoanAmount}
          setRevisedLoanAmount={setRevisedLoanAmount}
          revisedRoi={revisedRoi}
          setRevisedRoi={setRevisedRoi}
          chargesData={chargesData}
          notEligibleTopUpAccountType={notEligibleTopUpAccountType}
          validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
          statuses={statuses}
          subStatus={subStatus}
          enabledMultiLoanAdjsutmentTopUp={enabledMultiLoanAdjsutmentTopUp}
          prepledgeLoanMap={updatedPrepledgeLoanMap}
          disabledSchemeFields={disabledSchemeFields}
          exposureData={exposureData}
          actualLoanAmountWithInterest={actualLoanAmountWithInterest}
          updatedInterestLtv={updatedInterestLtv}
          totalOutstandingAmount={totalOutstandingAmount}
          enabledLtvSchemeBased={enabledLtvSchemeBased}
          enabledApiBasedLtv={enabledApiBasedLtv}
          collateralValue={collateralValue}
          loanData={loanData}
          refreshValue={refreshValue}
          form60Link={form60Link}
          setForm60Link={setForm60Link}
          />
           {(enabledCreditAssessmentOnLoanDetails && Number(criffEnabledAmount) > 250000 && selectedScheme?.schemeCode && referral) &&
          <>
          <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ margin: "0 2% 2%", width: "96%" }}
            >
              <InFlowLoanDetails 
              editable={editable}
              annualIncome={annualIncome}
              setAnnualIncome={setAnnualIncome}
              handleBlurAnnualIncome={handleBlurAnnualIncome}
              totalInFlowIncome={totalInFlowIncome}
              setAdditionalIncomeList={setAdditionalIncomeList}
              additionalIncomeList={additionalIncomeList}
              setCallInProgress={setCallInProgress}
              foirValueAmount={foirValueAmount}
            />
            </Grid>
          <Grid
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ margin: "1%", width: "100%" }}
            >
              <OutFlowLoanDetails 
              editable={editable} 
              exposureData={exposureData}
              totalOutflowAmt={totalOutflowAmt} 
              actualLoanAmount={actualLoanAmount}
              creditScore={creditScore}
              onCalculateCreditScore={getCreditScore}
              otherEmi={otherEmi}
              allowedOutFlowValue={allowedOutFlowValue}
              getLoanArray={getLoanArray}
              totalOutstandingAmount={totalOutstandingAmount}
              totalPreviousLoanInterestAmount={totalPreviousLoanInterestAmount}
              totalCurrentLoanInterestAmount={totalCurrentLoanInterestAmount}
              cibilObiligationsData={cibilObiligationsData}/>
            </Grid>
            </>
          }
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: "end" }}
          >
          { !firstTab &&  <Button
                              // style={{ margin: "5px" }}
                              size="small"
                              className={classes.nextButton1}
                              // className="bg-gradient-theme-left border-0"
                              onClick={() => setBack()}
                            >
                              Back
               </Button>}
            <Button
              size="small"
              className={classes.nextButton}
              // disabled={callInProgress || disableNext}
              onClick={(event) => {
                if (
                  status === loanApplicationStatus?.inProcess ||
                  status === loanApplicationStatus?.aadhaar ||
                  status === loanApplicationStatus?.selfie
                ) {
                  handleCreateOrnamentSubmit(event);
                } else {
                  handleNext();
                }
              }}
              disabled={recalculateAmount}
            >
              Next
            </Button>
          </Grid>

          {toast && (
            <ToastModal
              toastMessage={toastMessage}
              toastMessageType={toastMessageType}
              toastUpdate={toastUpdate}
            />
          )}
          {callInProgress && (
            <CircularProgress callInProgress={callInProgress} />
          )}
          {viewImageModal && (
            <ViewImageModal
              showModal={viewImageModal}
              closeModal={closeViewImageModal}
              imageUrl={imageUrl}
            />
          )}
        </Grid>
      </Grid>
      {showOrnamentTableModal && (
        <OrnamentTableModal
          showModal={showOrnamentTableModal}
          closeModal={closeOrnamentTableModal}
          showUpload={showUpload}
          setShowUpload={setShowUpload}
          editable={editable}
          getOrnamentData={getOrnamentData}
          handleChange={handleChange}
          lastIndex={lastIndex}
          setLastIndex={setLastIndex}
          groupDetails={groupDetails}
          updateOrnamentDetails={updateOrnamentDetails}
          tableData={tableData}
          ornamentList={ornamentList}
          handleOrnamentValue={handleOrnamentValue}
          handleStoneWeight={handleStoneWeight}
          handleOrnamentCount={handleOrnamentCount}
          handleCalculateWeight={handleCalculateWeight}
          packetError={packetError}
          handleDeductionUpdate={handleDeductionUpdate}
          ornamentValues={ornamentValues}
          availablePacketNumber={availablePacketNumber}
          alreadyPacket={alreadyPacket}
          childClasses={classes}
          enabelPacketNumber={enabelPacketNumber}
          setGroupDetails={setGroupDetails}
          addNextRow={addNextRow}
          editIndex={editIndex}
          editIndexData={editIndexData}
          showDeleteButton={((checkForAuditedFlagOrnamentFlag && loanType === "RE_PLEDGE" && (userDetails?.rootHierarchy || (!userDetails?.rootHierarchy && subStatus === repledgeCaseListName?.partRelease))) || !checkForAuditedFlagOrnamentFlag || loanType !== "RE_PLEDGE")}
          checkForAuditedFlagOrnamentFlag={loanType === "RE_PLEDGE" ? checkForAuditedFlagOrnamentFlag : false}
          userDetails={userDetails}
          groupDetailsOriginal={groupDetailsOriginal}
          enabledValidationForRepledgeOrnament={enabledValidationForRepledgeOrnament}
          toastUpdate={toastUpdate}
          enabledSamePacketNumberOrnamentCheck={enabledSamePacketNumberOrnamentCheck}
          loanType={loanType}
          enabledLeadValidateForNewLoan={enabledLeadValidateForNewLoan}
          minNetWeightValue={minNetWeightValue}
          featureFlags={featureFlags}
          subStatus={subStatus}
          disableExistingOrnamentFields={disableExistingOrnamentFields}
          blurCompletedRef={blurCompletedRef}
          productType={productType}
        />
      )}
      {showModal && (
        <LoanSchemeModal
          selectedScheme={loanSchemeCode}
          selectedSchemeArary={selectedSchemeArary}
          showModal={showModal}
          closeModal={CloseLoanSchemeModal}
          classesChild={classes}
          loanApplicationId={loanApplicationId}
          editable={editable}
          enabledMinMAxPercentageFieldsCharges={enabledMinMAxPercentageFieldsCharges}
          featureFlags={featureFlags}
          enableMinAndAnnualInterestRate={enableMinAndAnnualInterestRate}
        />
      )}
      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
          classes={classes}
        />
      )}
      {confirmationModalBulletScheme && (
        <ConfirmationModal
          confirmationModal={confirmationModalBulletScheme}
          confirmationModalHeader={confirmationModalHeaderBulletScheme}
          confirmationModalMsg={confirmationModalMsgBulletScheme}
          handleNegativeButton={handleNegativeResponseBulletScheme}
          handlePositiveButton={handlePositiveResponseBulletScheme}
          classes={classes}
        />
      )}
    </div>
  );
};

Ornament.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  loanApplicationNumber: PropTypes.object,
  editable: PropTypes.object,
};

export default Ornament;
